(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-template"]) return;
  try {
    
  const loggedCustomerEmail = () => {
    const inputElement = document.querySelector('[data-customer-email]')
    return inputElement?.dataset?.customerEmail
  }

  const isNewchargeCheckoutRedirectionActive = () => {
    const urlSearchParams = new URLSearchParams(window.location.search)
    return (
      document.querySelector('meta[name="newcharge_checkout_redirection_active"]')?.content === 'true' ||
      urlSearchParams.get('checkout') === 'newcharge'
    )
  }

  const buildNewchargeCheckoutLoadedUrl = (url, cartJsData) => {
    let payload = {
      email: loggedCustomerEmail() ?? '',
      currency: cartJsData.currency,
      original_total_price: cartJsData.original_total_price,
      token: cartJsData.token,
      total_price: cartJsData.total_price,
      items: cartJsData.items.map(item => {
        let properties = {}
        for (let property in item.properties) {
          if (property.startsWith('_bundle_part_')) {
            properties[property] = item.properties[property]
          }
        }
        return {
          properties: properties,
          quantity: item.quantity,
          variant_id: item.variant_id,
          price: item.price,
          sku: item.sku
        }
      })
    }

    const newchargeCheckoutUrlLoaded = new URL(url)
    newchargeCheckoutUrlLoaded.searchParams.append('short_cart', JSON.stringify(payload))

    return newchargeCheckoutUrlLoaded
  }

  const form = document.querySelector('#cart_form')
  if (isNewchargeCheckoutRedirectionActive()) {
    form.addEventListener('submit', async (e) => {
      e.preventDefault()

      try {
        const response = await fetch('/cart.js')
        const cartJsData = await response.json()
        const newchargeCheckoutUrl = document.querySelector('meta[name="newcharge_checkout_url"]')?.content
        const newchargeCheckoutLoadedUrl = buildNewchargeCheckoutLoadedUrl(
          newchargeCheckoutUrl,
          cartJsData
        )
        window.location.href = newchargeCheckoutLoadedUrl
      } catch (error) {
        console.log('error:', error)
      }
    })
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s-announcement"]) return;
  try {
    

// Gestion de la rotation des annonces
let announcementInterval = setInterval(() => {
  let announcements = document.querySelector(".s-announcement .announcements")
  let currentAnnouncement = announcements.querySelector("p")
  let announcementWidth = document.querySelector(".s-announcement .announcements").offsetWidth
  
  if (currentAnnouncement.hasAttribute("data-copy")) {
    currentAnnouncement.remove()
    currentAnnouncement = announcements.querySelector("p")
  }
 
  announcementWidth = document.querySelector(".s-announcement .announcements").offsetWidth
  announcements.scroll({ left: announcementWidth, behavior: 'smooth' })

  setTimeout(() => {
    announcements.append(currentAnnouncement.cloneNode(true))
    announcements.firstElementChild.setAttribute("data-copy", "")
  }, 2000);
}, 5000)


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s-collectionSelector"] && !window.DesignMode) return;
  try {
    

window.addEventListener("load", e => {
  return
  document.querySelectorAll(".s-collection-selector a").forEach(el => {
    el.setAttribute("href","#collectionSelector")
    el.addEventListener("click", e => {
      // Mise à jour de la collection selectionnée
      document.querySelectorAll(".s-collection-selector li.active").forEach(el => el.classList.remove("active"))
      e.currentTarget.parentElement.classList.add("active")

      // Scroll jusqu'au sélecteur de collections
      document.querySelector("#collectionSelector").scrollIntoView({ behavior: 'smooth' })

      // Affichage du spinner
      slideDown(document.querySelector(".s-collection-selector .spinner"),200)

      // Supression du contenu
      setTimeout(() => document.querySelectorAll("section:not(.skip), #shopify-section-footer").forEach(el => fadeOut(el,400,el.remove())), 500);

      // Mise à jour du contenu de la page et dissimulation du spinner 
      let collectionUrl = e.currentTarget.getAttribute("data-link")
      loadCollectionContent(collectionUrl)
    })
  })
})

function loadCollectionContent(url) {
  let xhr = new XMLHttpRequest()

  xhr.onreadystatechange = function() {
    if (this.readyState == 4 && this.status == 200) {
      let parser = new DOMParser()
      let newHtml = parser.parseFromString(this.response, "text/html")

      newHtml.querySelectorAll("section:not(.skip), #shopify-section-footer").forEach(el => {
        el.style.display = "none"
        document.querySelector("body").append(el)
        fadeIn(el,200)
      })

      slideUp(document.querySelector(".s-collection-selector .spinner"),800)
      document.querySelectorAll('.trustpilot-widget').forEach(trustpilotbox => {
        window.Trustpilot.loadFromElement(trustpilotbox);
      })
    }
  }

  xhr.open("GET", url, true)
  xhr.send()
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s-product-abo-flex"] && !window.DesignMode) return;
  try {
    
  // Variables globales
  let options = document.querySelector(".product-options")

  // Miniature image clicks
  document.querySelectorAll(".product-miniature").forEach(element => {
    element.addEventListener("click", e => {
      // On récupère l'identifiant de la miniature
      let miniatureId = e.currentTarget.children[0].getAttribute("data-pm-id")
      // On trouve l'image correspondante
      let targetImage = document.querySelector(`[data-pi-id='${miniatureId}']`)
      // On récupère l'index de l'image
      let targetIndex = targetImage.parentElement.getAttribute("data-pi-index")

      // On met à jour l'image
      slideToProductImage(targetIndex)
      // On indique que le focus est sur cette image
      setCurrentActiveProductImage(targetIndex)
    })
  })

  // Product option clicks
  document.querySelectorAll(".option-value").forEach(element => {
    element.addEventListener("click", e => {
      // Si l'option n'est pas disponible, ne rien faire
      if (e.currentTarget.classList.contains("unavailable")) return

      // On récupère la nouvelle option
      let newOption = e.currentTarget.getAttribute("data-option-value")

      // On met à jour visuellement les options actives
      changeSelectedOption(e.currentTarget.parentElement, newOption)
      // On met à jour les choix d'options disponibles
      updateOptionsAvailability()
      // On met à jour les infos produits
      updateProductData()
      // On met à jour la variante dans le master select
      changeSelectedVariant()
      // On met à jour l'image
      updateImage()
    })
  })

  // Scroll options (Desktop)
  document.querySelectorAll(".product-option").forEach(element => {
    let numberOfOptions = parseInt(element.getAttribute("data-option-size"))

    if (window.screen.width > 1200 && numberOfOptions > 3) {
      element.querySelector(".option-values").addEventListener("wheel", e => {
        e.preventDefault()

        element.querySelector(".option-values").scrollLeft += 100 * e.deltaY / Math.abs(e.deltaY)
      })
    }
  })

  // Carousel arrow clicks
  document.querySelectorAll(".option-value__arrow").forEach(element => {
    element.addEventListener("click", e => {
      let optionValues = element.parentElement.previousElementSibling

      if (element.classList.contains("previous")) {
        optionValues.scroll({left: optionValues.scrollLeft - 100, behavior: 'smooth'})
      } else {
        optionValues.scroll({top: 0, left: optionValues.scrollLeft + 100, behavior: 'smooth'})
        element.previousElementSibling.classList.remove("c-h")
      }
    })
  })


  document.querySelectorAll(".product-miniature__arrow").forEach(element => {
    element.addEventListener("click", e => {
      let miniatures = element.parentElement.previousElementSibling

      if (element.classList.contains("previous")) {
        miniatures.scroll({top: miniatures.scrollTop - 100, behavior: 'smooth'})
      } else {
        miniatures.scroll({top: miniatures.scrollTop + 100, left: 0, behavior: 'smooth'})
      }
    })
  })

  // Add to cart click
  document.querySelector(".product-button.atc").addEventListener("click", e => addToJooneCart())

  // Helper functions
  function slideToProductImage(index) {
    // Si l'image n'est pas accessible, ne rien faire
    if (document.querySelector(`.product-image.index-${index}`) == null) return

    // Sinon, faire scroller le slider jusqu'à l'image
    document.querySelector(`.product-image.index-${index}`).scrollIntoView({ behavior: 'smooth', block: 'nearest' })
  }

  function setCurrentActiveProductImage(index) {
    // Si l'image n'est pas accessible, ne rien faire
    if (document.querySelector(`.product-image.index-${index}`) == null) return

    // Sinon, mettre à jour l'image active dans les données HTML
    document.querySelector(".product-images").setAttribute("data-active-index", index)
  }


  function slideToProductMiniature(index) {
    if (document.querySelector(`.product-miniature.index-${index}`) == null) return

    document.querySelector(`.product-miniature.index-${index}`).scrollIntoView({ behavior: 'smooth', block: 'nearest' })
  }

  function setCurrentActiveProductMiniature(index) {
    if (document.querySelector(`.product-miniature.index-${index}`) == null) return

    document.querySelector(".product-miniatures").setAttribute("data-active-index", index)
  }

  function changeSelectedOption(element, value) {
    // On met à jour l'option active dans les données HTML
    element.setAttribute("data-active-option", value)
    // On retire la bordure verte de l'option active précédente
    element.querySelector(".option-value.active").classList.remove("active")
    // On applique la bordure verte pour la nouvelle option active
    element.querySelector(`[data-option-value="${value}"]`).classList.add("active")
  }

  function getVariantId(firstOption, secondOption, thirdOption) {
    let variantName, variantId
    variantName = getVariantName(firstOption, secondOption, thirdOption)
    variantId = document.querySelector(`[data-variant-title="${variantName}"]`)?.getAttribute("value")

    return variantId
  }

  function getVariantName(firstOption, secondOption, thirdOption) {
    if (thirdOption == null && options.querySelector("[data-option-number='3']") != null) {
      thirdOption = options.querySelector("[data-option-number='3'] .option-values").getAttribute("data-active-option")
    }

    if (secondOption == null && options.querySelector("[data-option-number='2']") != null) {
      secondOption = options.querySelector("[data-option-number='2'] .option-values").getAttribute("data-active-option")
    }

    if (firstOption == null && options.querySelector("[data-option-number='1']") != null) {
      firstOption = options.querySelector("[data-option-number='1'] .option-values").getAttribute("data-active-option")
    }

    if (thirdOption != null) {
      variantName = firstOption + " / " + secondOption + " / " + thirdOption
    } else if (secondOption != null) {
      variantName = firstOption + " / " + secondOption
    } else {
      variantName = firstOption
    }

    return variantName
  }

  function updateOptionsAvailability() {
    let optionValue, variantId, variantAvailability
    let productOptionsLength
    let firstActiveOption = getActiveOptionName(1)
    let secondActiveOption = getActiveOptionName(2)
    let thirdActiveOption = getActiveOptionName(3)

    if (thirdActiveOption != null) {
      productOptionsLength = 3
    } else if (secondActiveOption != null) {
      productOptionsLength = 2
    } else {
      productOptionsLength = 1
    }

    if (productOptionsLength == 3) {
      options.querySelectorAll(`[data-option-number='1'] .option-value`).forEach(element => {
        optionValue = element.getAttribute("data-option-value")
        variantId = getVariantId(optionValue, secondActiveOption, thirdActiveOption)
        variantAvailability = options.querySelector(`[value='${variantId}']`)?.getAttribute("data-variant-available")

        toggleAvailableClass(element, variantAvailability == "true")
      })

      options.querySelectorAll(`[data-option-number='2'] .option-value`).forEach(element => {
        optionValue = element.getAttribute("data-option-value")
        variantId = getVariantId(firstActiveOption, optionValue, thirdActiveOption)
        variantAvailability = options.querySelector(`[value='${variantId}']`)?.getAttribute("data-variant-available")

        toggleAvailableClass(element, variantAvailability == "true")
      })

      options.querySelectorAll(`[data-option-number='3'] .option-value`).forEach(element => {
        optionValue = element.getAttribute("data-option-value")
        variantId = getVariantId(firstActiveOption, secondActiveOption, optionValue)
        variantAvailability = options.querySelector(`[value='${variantId}']`)?.getAttribute("data-variant-available")

        toggleAvailableClass(element, variantAvailability == "true")
      })
    } else if (productOptionsLength == 2) {
      options.querySelectorAll(`[data-option-number='1'] .option-value`).forEach(element => {
        optionValue = element.getAttribute("data-option-value")
        variantId = getVariantId(optionValue, secondActiveOption)
        variantAvailability = options.querySelector(`[value='${variantId}']`)?.getAttribute("data-variant-available")

        toggleAvailableClass(element, variantAvailability == "true")
      })

      options.querySelectorAll(`[data-option-number='2'] .option-value`).forEach(element => {
        optionValue = element.getAttribute("data-option-value")
        variantId = getVariantId(firstActiveOption, optionValue)
        variantAvailability = options.querySelector(`[value='${variantId}']`)?.getAttribute("data-variant-available")

        toggleAvailableClass(element, variantAvailability == "true")
      })
    } else {
      options.querySelectorAll(`[data-option-number='1'] .option-value`).forEach(element => {
        optionValue = element.getAttribute("data-option-value")
        variantId = getVariantId(optionValue)
        variantAvailability = options.querySelector(`[value='${variantId}']`)?.getAttribute("data-variant-available")

        toggleAvailableClass(element, variantAvailability == "true")
      })
    }
  }

  function toggleAvailableClass(element, available) {
    if (available) {
      element.classList.remove("unavailable")
      element.removeAttribute("disabled")
    } else {
      element.classList.add("unavailable")
      element.setAttribute("disabled", "")
    }
  }

  function getActiveOptionName(index) {
    if (options.querySelector(`[data-option-number='${index}']`) == null) return null

    let activeOptionName
    activeOptionName = options.querySelector(`[data-option-number='${index}'] .option-values`).getAttribute("data-active-option")

    return activeOptionName
  }

  function updateProductData() {
    let id = getVariantId()
    let newPrice = options.querySelector(`[value='${id}']`).getAttribute("data-variant-price")
    let newComparePrice = options.querySelector(`[value='${id}']`).getAttribute("data-variant-compare")
    let newAvailability = options.querySelector(`[value='${id}']`).getAttribute("data-variant-available")

    if (newComparePrice != "") {
      document.querySelector(".product-compare").classList.remove("c-h")
    } else {
      document.querySelector(".product-compare").classList.add("c-h")
    }

    document.querySelector(".product-compare").textContent = newComparePrice
    document.querySelector(".product-price").textContent = newPrice
    document.querySelector(".product-button.atc span").textContent = newPrice
  }

  const skuForVariant = (id) => window.ShopifyAnalytics.meta.product.variants.find(v => v.id == id)['sku']

  function changeSelectedVariant() {
    const odijKitLink = document.querySelector('#odij-kit-link')
    const variantId = getVariantId()

    if (odijKitLink) {
      odijKitLink.href = `/pages/kit-essai-couche-pharmacies?sku=${skuForVariant(variantId)}&id=${variantId}`
    }
    options.querySelector(".product-variants__select").value = variantId
  }

  function updateImage() {
    let id = getVariantId()
    let newImageId = options.querySelector(`[value='${id}']`).getAttribute("data-variant-image")
    let targetImage = document.querySelector(`[data-pi-id='${newImageId}']`)

    if (targetImage != null) {
      let targetIndex = targetImage.parentElement.getAttribute("data-pi-index")
      slideToProductImage(targetIndex)
      setCurrentActiveProductImage(targetIndex)
    }
  }

  async function addToJooneCart() {
    document.querySelector(".s-header .cart .number").classList.remove("c-h")
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s-product-abo-mixte"] && !window.DesignMode) return;
  try {
    

// Variables globales
let options = document.querySelector(".product-options")

// Miniature image clicks
document.querySelectorAll(".product-miniature").forEach(el => {
  el.addEventListener("click", e => {
    // On récupère l'identifiant de la miniature
    let miniatureId = e.currentTarget.children[0].getAttribute("data-pm-id")
    // On trouve l'image correspondante
    let targetImage = document.querySelector(`[data-pi-id='${miniatureId}']`)
    // On récupère l'index de l'image
    let targetIndex = targetImage.parentElement.getAttribute("data-pi-index")
    // On met à jour l'image
    slideToProductImage(targetIndex)
    // On indique que le focus est sur cette image
    setCurrentActiveProductImage(targetIndex)
  })
})

// Product option clicks
document.querySelectorAll(".option-value").forEach(el => {
  el.addEventListener("click", e => {
    // Si l'option n'est pas disponible, ne rien faire
    if (e.currentTarget.classList.contains("unavailable")) return
    // On récupère la nouvelle option
    let newOption = e.currentTarget.getAttribute("data-option-value")
    // On met à jour visuellement les options actives
    changeSelectedOption(e.currentTarget.parentElement, newOption)
    // On met à jour les choix d'options disponibles
    updateOptionsAvailability()
    // On met à jour les infos produits
    updateProductData()
    // On met à jour la variante dans le master select
    changeSelectedVariant()
    // On met à jour l'image
    updateImage()
  })
})

// Scroll options (Desktop)
document.querySelectorAll(".product-option").forEach(el => {
  let numberOfOptions = parseInt(el.getAttribute("data-option-size"))
  if (window.screen.width > 1200 && numberOfOptions > 3) {
    el.querySelector(".option-values").addEventListener("wheel", e => {
      e.preventDefault()
      el.querySelector(".option-values").scrollLeft += 100 * e.deltaY / Math.abs(e.deltaY)
    })
  }
})

// Carousel arrow clicks
document.querySelectorAll(".option-value__arrow").forEach(el => {
  el.addEventListener("click", e => {
    let optionValues = el.parentElement.previousElementSibling
    if (el.classList.contains("previous")) optionValues.scroll({left: optionValues.scrollLeft - 100, behavior: 'smooth'})
    else {
      optionValues.scroll({top: 0, left: optionValues.scrollLeft + 100, behavior: 'smooth'})
      el.previousElementSibling.classList.remove("c-h")
    }
  })
})


document.querySelectorAll(".product-miniature__arrow").forEach(el => {
  el.addEventListener("click", e => {
    let miniatures = el.parentElement.previousElementSibling
    if (el.classList.contains("previous")) miniatures.scroll({top: miniatures.scrollTop - 100, behavior: 'smooth'})
    else miniatures.scroll({top: miniatures.scrollTop + 100, left: 0, behavior: 'smooth'})
  })
})

// Add to cart click
document.querySelector(".product-button.atc").addEventListener("click", e => addToJooneCart())


// Helper functions
function slideToProductImage(index) {
  // Si l'image n'est pas accessible, ne rien faire
  if (document.querySelector(`.product-image.index-${index}`) == null) return
  // Sinon, faire scroller le slider jusqu'à l'image
  document.querySelector(`.product-image.index-${index}`).scrollIntoView({ behavior: 'smooth', block: 'nearest' })
}

function setCurrentActiveProductImage(index) {
  // Si l'image n'est pas accessible, ne rien faire
  if (document.querySelector(`.product-image.index-${index}`) == null) return
  // Sinon, mettre à jour l'image active dans les données HTML
  document.querySelector(".product-images").setAttribute("data-active-index", index)
}


function slideToProductMiniature(index) {
  if (document.querySelector(`.product-miniature.index-${index}`) == null) return
  document.querySelector(`.product-miniature.index-${index}`).scrollIntoView({ behavior: 'smooth', block: 'nearest' })
}

function setCurrentActiveProductMiniature(index) {
  if (document.querySelector(`.product-miniature.index-${index}`) == null) return
  document.querySelector(".product-miniatures").setAttribute("data-active-index", index)
}

function changeSelectedOption(el, value) {
  // On met à jour l'option active dans les données HTML
  el.setAttribute("data-active-option", value)
  // On retire la bordure verte de l'option active précédente
  el.querySelector(".option-value.active").classList.remove("active")
  // On applique la bordure verte pour la nouvelle option active
  el.querySelector(`[data-option-value="${value}"]`).classList.add("active")
}

function getVariantId(firstOption, secondOption, thirdOption) {
  let variantName, variantId
  variantName = getVariantName(firstOption, secondOption, thirdOption)

  variantId = document.querySelector(`[data-variant-title="${variantName}"]`)?.getAttribute("value")
  return variantId
}

function getVariantName(firstOption, secondOption, thirdOption) {

  if (thirdOption == null && options.querySelector("[data-option-number='3']") != null) {
    thirdOption = options.querySelector("[data-option-number='3'] .option-values").getAttribute("data-active-option")
  }

  if (secondOption == null && options.querySelector("[data-option-number='2']") != null) {
    secondOption = options.querySelector("[data-option-number='2'] .option-values").getAttribute("data-active-option")
  }

  if (firstOption == null && options.querySelector("[data-option-number='1']") != null) {
    firstOption = options.querySelector("[data-option-number='1'] .option-values").getAttribute("data-active-option")
  }

  if (thirdOption != null) {
    variantName = firstOption + " / " + secondOption + " / " + thirdOption
  } else if (secondOption != null) {
    variantName = firstOption + " / " + secondOption
  } else {
    variantName = firstOption
  }

  return variantName
}

function updateOptionsAvailability() {
  let optionValue, variantId, variantAvailability
  let productOptionsLength
  let firstActiveOption = getActiveOptionName(1)
  let secondActiveOption = getActiveOptionName(2)
  let thirdActiveOption = getActiveOptionName(3)

  if (thirdActiveOption != null) {
    productOptionsLength = 3
  } else if (secondActiveOption != null) {
    productOptionsLength = 2
  } else {
    productOptionsLength = 1
  }

  if (productOptionsLength == 3) {
    options.querySelectorAll(`[data-option-number='1'] .option-value`).forEach(el => {
      optionValue = el.getAttribute("data-option-value")

      variantId = getVariantId(optionValue, secondActiveOption, thirdActiveOption)
      variantAvailability = options.querySelector(`[value='${variantId}']`)?.getAttribute("data-variant-available")
      toggleAvailableClass(el, variantAvailability == "true")
    })

    options.querySelectorAll(`[data-option-number='2'] .option-value`).forEach(el => {
      optionValue = el.getAttribute("data-option-value")
      variantId = getVariantId(firstActiveOption, optionValue, thirdActiveOption)
      variantAvailability = options.querySelector(`[value='${variantId}']`)?.getAttribute("data-variant-available")
      toggleAvailableClass(el, variantAvailability == "true")
    })

    options.querySelectorAll(`[data-option-number='3'] .option-value`).forEach(el => {
      optionValue = el.getAttribute("data-option-value")
      variantId = getVariantId(firstActiveOption, secondActiveOption, optionValue)
      variantAvailability = options.querySelector(`[value='${variantId}']`)?.getAttribute("data-variant-available")
      toggleAvailableClass(el, variantAvailability == "true")
    })
  } else if (productOptionsLength == 2) {
    options.querySelectorAll(`[data-option-number='1'] .option-value`).forEach(el => {
      optionValue = el.getAttribute("data-option-value")
      variantId = getVariantId(optionValue, secondActiveOption)
      variantAvailability = options.querySelector(`[value='${variantId}']`)?.getAttribute("data-variant-available")
      toggleAvailableClass(el, variantAvailability == "true")
    })

    options.querySelectorAll(`[data-option-number='2'] .option-value`).forEach(el => {
      optionValue = el.getAttribute("data-option-value")
      variantId = getVariantId(firstActiveOption, optionValue)
      variantAvailability = options.querySelector(`[value='${variantId}']`)?.getAttribute("data-variant-available")
      toggleAvailableClass(el, variantAvailability == "true")
    })
  } else {
    options.querySelectorAll(`[data-option-number='1'] .option-value`).forEach(el => {
      optionValue = el.getAttribute("data-option-value")
      variantId = getVariantId(optionValue)
      variantAvailability = options.querySelector(`[value='${variantId}']`)?.getAttribute("data-variant-available")
      toggleAvailableClass(el, variantAvailability == "true")
    })
  }
}

function toggleAvailableClass(el, available) {
  if (available) {
    el.classList.remove("unavailable")
    el.removeAttribute("disabled")
  } else {
    el.classList.add("unavailable")
    el.setAttribute("disabled", "")
  }
}

function getActiveOptionName(index) {
  let activeOptionName

  if (options.querySelector(`[data-option-number='${index}']`) == null) return null

  activeOptionName = options.querySelector(`[data-option-number='${index}'] .option-values`).getAttribute("data-active-option")

  return activeOptionName
}

function updateProductData() {
  let id = getVariantId()
  let newPrice = options.querySelector(`[value='${id}']`).getAttribute("data-variant-price")
  let newComparePrice = options.querySelector(`[value='${id}']`).getAttribute("data-variant-compare")
  let newAvailability = options.querySelector(`[value='${id}']`).getAttribute("data-variant-available")

  if (newComparePrice != "") document.querySelector(".product-compare").classList.remove("c-h")
  else document.querySelector(".product-compare").classList.add("c-h")

  document.querySelector(".product-compare").textContent = newComparePrice
  document.querySelector(".product-price").textContent = newPrice
  document.querySelector(".product-button.atc span").textContent = newPrice

  /*if(newAvailability == "true") {
    document.querySelector(".product-button.atc").classList.remove("c-h")
    document.querySelector(".product-button.oos").classList.add("c-h")
  } else {
    document.querySelector(".product-button.atc").classList.add("c-h")
    document.querySelector(".product-button.oos").classList.remove("c-h")
  }*/
}

const skuForVariant = (id) => window.ShopifyAnalytics.meta.product.variants.find(v => v.id == id)['sku']

function changeSelectedVariant() {
  const odijKitLink = document.querySelector('#odij-kit-link')
  const variantId = getVariantId()

  if (odijKitLink) {
    odijKitLink.href = `/pages/kit-essai-couche-pharmacies?sku=${skuForVariant(variantId)}&id=${variantId}`
  }
  options.querySelector(".product-variants__select").value = variantId
}

function updateImage() {
  let id = getVariantId()
  let newImageId = options.querySelector(`[value='${id}']`).getAttribute("data-variant-image")
  let targetImage = document.querySelector(`[data-pi-id='${newImageId}']`)
  if (targetImage != null) {
    let targetIndex = targetImage.parentElement.getAttribute("data-pi-index")
    slideToProductImage(targetIndex)
    setCurrentActiveProductImage(targetIndex)
  }
}

async function addToJooneCart() {
  document.querySelector(".s-header .cart .number").classList.remove("c-h")

  //await addVariantToCart(getVariantId(), 1)

  // Rafraichir l'incentive cart

  /*if (document.querySelector("#incentive-cart-popin") != null) document.querySelector("#incentive-cart-popin").style.display = "block"
  else if (document.querySelector("#incentive-cart-slide") != null) document.querySelector("#incentive-cart-slide").style.display = "block"
  else return console.log("No cart loaded on the page")*/
}

/*function addVariantToCart(id, quantity) {
  return new Promise(resolve => {
    let change = JSON.stringify({ 'id': id.toString(), 'quantity': quantity.toString() })

    let xhr = new XMLHttpRequest()

    xhr.onreadystatechange = function() { if (this.readyState == 4 && this.status == 200) resolve() }

    xhr.open("POST", "/cart/add.js", true)
    xhr.setRequestHeader("Content-Type", "application/json")
    xhr.send(change)
  })
}

function getCart() {
  return new Promise(resolve => {
    let xhr = new XMLHttpRequest()

    xhr.onreadystatechange = function() { if (this.readyState == 4 && this.status == 200) resolve() }

    xhr.open("GET", "/cart.js", true)
    xhr.send()
  })
}*/


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s-product-couche-one-v2"] && !window.DesignMode) return;
  try {
    

// Variables globales
let options = document.querySelector(".product-options")

// Miniature image clicks
document.querySelectorAll(".product-miniature").forEach(el => {
  el.addEventListener("click", e => {
    // On récupère l'identifiant de la miniature
    let miniatureId = e.currentTarget.children[0].getAttribute("data-pm-id")
    // On trouve l'image correspondante
    let targetImage = document.querySelector(`[data-pi-id='${miniatureId}']`)
    // On récupère l'index de l'image
    let targetIndex = targetImage.parentElement.getAttribute("data-pi-index")
    // On met à jour l'image
    slideToProductImage(targetIndex)
    // On indique que le focus est sur cette image
    setCurrentActiveProductImage(targetIndex)
  })
})

// Product option clicks
document.querySelectorAll(".option-value").forEach(el => {
  el.addEventListener("click", e => {
    // Si l'option n'est pas disponible, ne rien faire
    if (e.currentTarget.classList.contains("unavailable")) return
    // On récupère la nouvelle option
    let newOption = e.currentTarget.getAttribute("data-option-value")
    // On met à jour visuellement les options actives
    changeSelectedOption(e.currentTarget.parentElement, newOption)
    // On met à jour les choix d'options disponibles
    updateOptionsAvailability()
    // On met à jour les infos produits
    updateProductData()
    // On met à jour la variante dans le master select
    changeSelectedVariant()
    // On met à jour l'image
    updateImage()
  })
})

// Scroll options (Desktop)
document.querySelectorAll(".product-option").forEach(el => {
  let numberOfOptions = parseInt(el.getAttribute("data-option-size"))
  if (window.screen.width > 1200 && numberOfOptions > 3) {
    el.querySelector(".option-values").addEventListener("wheel", e => {
      e.preventDefault()
      el.querySelector(".option-values").scrollLeft += 100 * e.deltaY / Math.abs(e.deltaY)
    })
  }
})

// Carousel arrow clicks
document.querySelectorAll(".option-value__arrow").forEach(el => {
  el.addEventListener("click", e => {
    let optionValues = el.parentElement.previousElementSibling
    if (el.classList.contains("previous")) optionValues.scroll({left: optionValues.scrollLeft - 100, behavior: 'smooth'})
    else {
      optionValues.scroll({top: 0, left: optionValues.scrollLeft + 100, behavior: 'smooth'})
      el.previousElementSibling.classList.remove("c-h")
    }
  })
})


document.querySelectorAll(".product-miniature__arrow").forEach(el => {
  el.addEventListener("click", e => {
    let miniatures = el.parentElement.previousElementSibling
    if (el.classList.contains("previous")) miniatures.scroll({top: miniatures.scrollTop - 100, behavior: 'smooth'})
    else miniatures.scroll({top: miniatures.scrollTop + 100, left: 0, behavior: 'smooth'})
  })
})

// Add to cart click
document.querySelector(".product-button.atc").addEventListener("click", e => addToJooneCart())


// Helper functions
function slideToProductImage(index) {
  // Si l'image n'est pas accessible, ne rien faire
  if (document.querySelector(`.product-image.index-${index}`) == null) return
  // Sinon, faire scroller le slider jusqu'à l'image
  document.querySelector(`.product-image.index-${index}`).scrollIntoView({ behavior: 'smooth', block: 'nearest' })
}

function setCurrentActiveProductImage(index) {
  // Si l'image n'est pas accessible, ne rien faire
  if (document.querySelector(`.product-image.index-${index}`) == null) return
  // Sinon, mettre à jour l'image active dans les données HTML
  document.querySelector(".product-images").setAttribute("data-active-index", index)
}


function slideToProductMiniature(index) {
  if (document.querySelector(`.product-miniature.index-${index}`) == null) return
  document.querySelector(`.product-miniature.index-${index}`).scrollIntoView({ behavior: 'smooth', block: 'nearest' })
}

function setCurrentActiveProductMiniature(index) {
  if (document.querySelector(`.product-miniature.index-${index}`) == null) return
  document.querySelector(".product-miniatures").setAttribute("data-active-index", index)
}

function changeSelectedOption(el, value) {
  // On met à jour l'option active dans les données HTML
  el.setAttribute("data-active-option", value)
  // On retire la bordure verte de l'option active précédente
  el.querySelector(".option-value.active").classList.remove("active")
  // On applique la bordure verte pour la nouvelle option active
  el.querySelector(`[data-option-value="${value}"]`).classList.add("active")
}

function getVariantId(firstOption, secondOption, thirdOption) {
  let variantName, variantId
  variantName = getVariantName(firstOption, secondOption, thirdOption)

  variantId = document.querySelector(`[data-variant-title="${variantName}"]`)?.getAttribute("value")
  return variantId
}

function getVariantName(firstOption, secondOption, thirdOption) {

  if (thirdOption == null && options.querySelector("[data-option-number='3']") != null) {
    thirdOption = options.querySelector("[data-option-number='3'] .option-values").getAttribute("data-active-option")
  }

  if (secondOption == null && options.querySelector("[data-option-number='2']") != null) {
    secondOption = options.querySelector("[data-option-number='2'] .option-values").getAttribute("data-active-option")
  }

  if (firstOption == null && options.querySelector("[data-option-number='1']") != null) {
    firstOption = options.querySelector("[data-option-number='1'] .option-values").getAttribute("data-active-option")
  }

  if (thirdOption != null) {
    variantName = firstOption + " / " + secondOption + " / " + thirdOption
  } else if (secondOption != null) {
    variantName = firstOption + " / " + secondOption
  } else {
    variantName = firstOption
  }

  return variantName
}

function updateOptionsAvailability() {
  let optionValue, variantId, variantAvailability
  let productOptionsLength
  let firstActiveOption = getActiveOptionName(1)
  let secondActiveOption = getActiveOptionName(2)
  let thirdActiveOption = getActiveOptionName(3)

  if (thirdActiveOption != null) {
    productOptionsLength = 3
  } else if (secondActiveOption != null) {
    productOptionsLength = 2
  } else {
    productOptionsLength = 1
  }

  if (productOptionsLength == 3) {
    options.querySelectorAll(`[data-option-number='1'] .option-value`).forEach(el => {
      optionValue = el.getAttribute("data-option-value")

      variantId = getVariantId(optionValue, secondActiveOption, thirdActiveOption)
      variantAvailability = options.querySelector(`[value='${variantId}']`)?.getAttribute("data-variant-available")
      toggleAvailableClass(el, variantAvailability == "true")
    })

    options.querySelectorAll(`[data-option-number='2'] .option-value`).forEach(el => {
      optionValue = el.getAttribute("data-option-value")
      variantId = getVariantId(firstActiveOption, optionValue, thirdActiveOption)
      variantAvailability = options.querySelector(`[value='${variantId}']`)?.getAttribute("data-variant-available")
      toggleAvailableClass(el, variantAvailability == "true")
    })

    options.querySelectorAll(`[data-option-number='3'] .option-value`).forEach(el => {
      optionValue = el.getAttribute("data-option-value")
      variantId = getVariantId(firstActiveOption, secondActiveOption, optionValue)
      variantAvailability = options.querySelector(`[value='${variantId}']`)?.getAttribute("data-variant-available")
      toggleAvailableClass(el, variantAvailability == "true")
    })
  } else if (productOptionsLength == 2) {
    options.querySelectorAll(`[data-option-number='1'] .option-value`).forEach(el => {
      optionValue = el.getAttribute("data-option-value")
      variantId = getVariantId(optionValue, secondActiveOption)
      variantAvailability = options.querySelector(`[value='${variantId}']`)?.getAttribute("data-variant-available")
      toggleAvailableClass(el, variantAvailability == "true")
    })

    options.querySelectorAll(`[data-option-number='2'] .option-value`).forEach(el => {
      optionValue = el.getAttribute("data-option-value")
      variantId = getVariantId(firstActiveOption, optionValue)
      variantAvailability = options.querySelector(`[value='${variantId}']`)?.getAttribute("data-variant-available")
      toggleAvailableClass(el, variantAvailability == "true")
    })
  } else {
    options.querySelectorAll(`[data-option-number='1'] .option-value`).forEach(el => {
      optionValue = el.getAttribute("data-option-value")
      variantId = getVariantId(optionValue)
      variantAvailability = options.querySelector(`[value='${variantId}']`)?.getAttribute("data-variant-available")
      toggleAvailableClass(el, variantAvailability == "true")
    })
  }
}

function toggleAvailableClass(el, available) {
  if (available) {
    el.classList.remove("unavailable")
    el.removeAttribute("disabled")
  } else {
    el.classList.add("unavailable")
    el.setAttribute("disabled", "")
  }
}

function getActiveOptionName(index) {
  let activeOptionName

  if (options.querySelector(`[data-option-number='${index}']`) == null) return null

  activeOptionName = options.querySelector(`[data-option-number='${index}'] .option-values`).getAttribute("data-active-option")

  return activeOptionName
}

function updateProductData() {
  let id = getVariantId()
  let newPrice = options.querySelector(`[value='${id}']`).getAttribute("data-variant-price")
  let newComparePrice = options.querySelector(`[value='${id}']`).getAttribute("data-variant-compare")
  let newAvailability = options.querySelector(`[value='${id}']`).getAttribute("data-variant-available")

  if (newComparePrice != "") document.querySelector(".product-compare").classList.remove("c-h")
  else document.querySelector(".product-compare").classList.add("c-h")

  document.querySelector(".product-compare").textContent = newComparePrice
  document.querySelector(".product-price").textContent = newPrice
  document.querySelector(".product-button.atc span").textContent = newPrice

  /*if(newAvailability == "true") {
    document.querySelector(".product-button.atc").classList.remove("c-h")
    document.querySelector(".product-button.oos").classList.add("c-h")
  } else {
    document.querySelector(".product-button.atc").classList.add("c-h")
    document.querySelector(".product-button.oos").classList.remove("c-h")
  }*/
}

const skuForVariant = (id) => window.ShopifyAnalytics.meta.product.variants.find(v => v.id == id)['sku']

function changeSelectedVariant() {
  const odijKitLink = document.querySelector('#odij-kit-link')
  if (odijKitLink) {
    odijKitLink.href = `/pages/kit-essai-couche-pharmacies?sku=${skuForVariant(getVariantId())}`
  }
  options.querySelector(".product-variants__select").value = getVariantId()
}

function updateImage() {
  let id = getVariantId()
  let newImageId = options.querySelector(`[value='${id}']`).getAttribute("data-variant-image")
  let targetImage = document.querySelector(`[data-pi-id='${newImageId}']`)
  if (targetImage != null) {
    let targetIndex = targetImage.parentElement.getAttribute("data-pi-index")
    slideToProductImage(targetIndex)
    setCurrentActiveProductImage(targetIndex)
  }
}

async function addToJooneCart() {
  document.querySelector(".s-header .cart .number").classList.remove("c-h")

  //await addVariantToCart(getVariantId(), 1)

  // Rafraichir l'incentive cart

  /*if (document.querySelector("#incentive-cart-popin") != null) document.querySelector("#incentive-cart-popin").style.display = "block"
  else if (document.querySelector("#incentive-cart-slide") != null) document.querySelector("#incentive-cart-slide").style.display = "block"
  else return console.log("No cart loaded on the page")*/
}

/*function addVariantToCart(id, quantity) {
  return new Promise(resolve => {
    let change = JSON.stringify({ 'id': id.toString(), 'quantity': quantity.toString() })

    let xhr = new XMLHttpRequest()

    xhr.onreadystatechange = function() { if (this.readyState == 4 && this.status == 200) resolve() }

    xhr.open("POST", "/cart/add.js", true)
    xhr.setRequestHeader("Content-Type", "application/json")
    xhr.send(change)
  })
}

function getCart() {
  return new Promise(resolve => {
    let xhr = new XMLHttpRequest()

    xhr.onreadystatechange = function() { if (this.readyState == 4 && this.status == 200) resolve() }

    xhr.open("GET", "/cart.js", true)
    xhr.send()
  })
}*/

document.querySelector('.product-options .button-wrapper').addEventListener('click', (event) => {
  event.preventDefault();

  const section = document.querySelector('.product-options .button-wrapper');

  const clickEventPath = event.composedPath().slice(0, -2);

  for (const element of clickEventPath) {
    if (element.classList.contains('first')) {
      oneShotClickHandler(element, section);
      break;
    } else if (element.classList.contains('second')) {
      subscriptionClickHandler(element, section);
      break;
    }
  }
})

const oneShotClickHandler = (element, section) => {
  const oldButton = document.querySelector(`[data-option-value="Acheter une fois"]`);

  const clickEvent = new MouseEvent('click', {
    view: window,
    bubbles: true,
    cancelable: true
  });

  oldButton.dispatchEvent(clickEvent);

  section.querySelector('.button-container[data-active]').removeAttribute('data-active');
  section.querySelector('.button-container.first').setAttribute('data-active', '');
}

const subscriptionClickHandler = (element, section) => {
  const oldButton = document.querySelector(`[data-option-value="S'abonner"]`);

  const clickEvent = new MouseEvent('click', {
    view: window,
    bubbles: true,
    cancelable: true
  });

  oldButton.dispatchEvent(clickEvent);

  section.querySelector('.button-container[data-active]').removeAttribute('data-active');
  section.querySelector('.button-container.second').setAttribute('data-active', '');
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s-product-couche-one"] && !window.DesignMode) return;
  try {
    

// Variables globales
let options = document.querySelector(".product-options")

// Miniature image clicks
document.querySelectorAll(".product-miniature").forEach(el => {
  el.addEventListener("click", e => {
    // On récupère l'identifiant de la miniature
    let miniatureId = e.currentTarget.children[0].getAttribute("data-pm-id")
    // On trouve l'image correspondante
    let targetImage = document.querySelector(`[data-pi-id='${miniatureId}']`)
    // On récupère l'index de l'image
    let targetIndex = targetImage.parentElement.getAttribute("data-pi-index")
    // On met à jour l'image
    slideToProductImage(targetIndex)
    // On indique que le focus est sur cette image
    setCurrentActiveProductImage(targetIndex)
  })
})

// Product option clicks
document.querySelectorAll(".option-value").forEach(el => {
  el.addEventListener("click", e => {
    // Si l'option n'est pas disponible, ne rien faire
    if (e.currentTarget.classList.contains("unavailable")) return
    // On récupère la nouvelle option
    let newOption = e.currentTarget.getAttribute("data-option-value")
    // On met à jour visuellement les options actives
    changeSelectedOption(e.currentTarget.parentElement, newOption)
    // On met à jour les choix d'options disponibles
    updateOptionsAvailability()
    // On met à jour les infos produits
    updateProductData()
    // On met à jour la variante dans le master select
    changeSelectedVariant()
    // On met à jour l'image
    updateImage()
  })
})

// Scroll options (Desktop)
document.querySelectorAll(".product-option").forEach(el => {
  let numberOfOptions = parseInt(el.getAttribute("data-option-size"))
  if (window.screen.width > 1200 && numberOfOptions > 3) {
    el.querySelector(".option-values").addEventListener("wheel", e => {
      e.preventDefault()
      el.querySelector(".option-values").scrollLeft += 100 * e.deltaY / Math.abs(e.deltaY)
    })
  }
})

// Carousel arrow clicks
document.querySelectorAll(".option-value__arrow").forEach(el => {
  el.addEventListener("click", e => {
    let optionValues = el.parentElement.previousElementSibling
    if (el.classList.contains("previous")) optionValues.scroll({left: optionValues.scrollLeft - 100, behavior: 'smooth'})
    else {
      optionValues.scroll({top: 0, left: optionValues.scrollLeft + 100, behavior: 'smooth'})
      el.previousElementSibling.classList.remove("c-h")
    }
  })
})


document.querySelectorAll(".product-miniature__arrow").forEach(el => {
  el.addEventListener("click", e => {
    let miniatures = el.parentElement.previousElementSibling
    if (el.classList.contains("previous")) miniatures.scroll({top: miniatures.scrollTop - 100, behavior: 'smooth'})
    else miniatures.scroll({top: miniatures.scrollTop + 100, left: 0, behavior: 'smooth'})
  })
})

// Add to cart click
document.querySelector(".product-button.atc").addEventListener("click", e => addToJooneCart())


// Helper functions
function slideToProductImage(index) {
  // Si l'image n'est pas accessible, ne rien faire
  if (document.querySelector(`.product-image.index-${index}`) == null) return
  // Sinon, faire scroller le slider jusqu'à l'image
  document.querySelector(`.product-image.index-${index}`).scrollIntoView({ behavior: 'smooth', block: 'nearest' })
}

function setCurrentActiveProductImage(index) {
  // Si l'image n'est pas accessible, ne rien faire
  if (document.querySelector(`.product-image.index-${index}`) == null) return
  // Sinon, mettre à jour l'image active dans les données HTML
  document.querySelector(".product-images").setAttribute("data-active-index", index)
}


function slideToProductMiniature(index) {
  if (document.querySelector(`.product-miniature.index-${index}`) == null) return
  document.querySelector(`.product-miniature.index-${index}`).scrollIntoView({ behavior: 'smooth', block: 'nearest' })
}

function setCurrentActiveProductMiniature(index) {
  if (document.querySelector(`.product-miniature.index-${index}`) == null) return
  document.querySelector(".product-miniatures").setAttribute("data-active-index", index)
}

function changeSelectedOption(el, value) {
  // On met à jour l'option active dans les données HTML
  el.setAttribute("data-active-option", value)
  // On retire la bordure verte de l'option active précédente
  el.querySelector(".option-value.active").classList.remove("active")
  // On applique la bordure verte pour la nouvelle option active
  el.querySelector(`[data-option-value="${value}"]`).classList.add("active")
}

function getVariantId(firstOption, secondOption, thirdOption) {
  let variantName, variantId
  variantName = getVariantName(firstOption, secondOption, thirdOption)

  variantId = document.querySelector(`[data-variant-title="${variantName}"]`)?.getAttribute("value")
  return variantId
}

function getVariantName(firstOption, secondOption, thirdOption) {

  if (thirdOption == null && options.querySelector("[data-option-number='3']") != null) {
    thirdOption = options.querySelector("[data-option-number='3'] .option-values").getAttribute("data-active-option")
  }

  if (secondOption == null && options.querySelector("[data-option-number='2']") != null) {
    secondOption = options.querySelector("[data-option-number='2'] .option-values").getAttribute("data-active-option")
  }

  if (firstOption == null && options.querySelector("[data-option-number='1']") != null) {
    firstOption = options.querySelector("[data-option-number='1'] .option-values").getAttribute("data-active-option")
  }

  if (thirdOption != null) {
    variantName = firstOption + " / " + secondOption + " / " + thirdOption
  } else if (secondOption != null) {
    variantName = firstOption + " / " + secondOption
  } else {
    variantName = firstOption
  }

  return variantName
}

function updateOptionsAvailability() {
  let optionValue, variantId, variantAvailability
  let productOptionsLength
  let firstActiveOption = getActiveOptionName(1)
  let secondActiveOption = getActiveOptionName(2)
  let thirdActiveOption = getActiveOptionName(3)

  if (thirdActiveOption != null) {
    productOptionsLength = 3
  } else if (secondActiveOption != null) {
    productOptionsLength = 2
  } else {
    productOptionsLength = 1
  }

  if (productOptionsLength == 3) {
    options.querySelectorAll(`[data-option-number='1'] .option-value`).forEach(el => {
      optionValue = el.getAttribute("data-option-value")

      variantId = getVariantId(optionValue, secondActiveOption, thirdActiveOption)
      variantAvailability = options.querySelector(`[value='${variantId}']`)?.getAttribute("data-variant-available")
      toggleAvailableClass(el, variantAvailability == "true")
    })

    options.querySelectorAll(`[data-option-number='2'] .option-value`).forEach(el => {
      optionValue = el.getAttribute("data-option-value")
      variantId = getVariantId(firstActiveOption, optionValue, thirdActiveOption)
      variantAvailability = options.querySelector(`[value='${variantId}']`)?.getAttribute("data-variant-available")
      toggleAvailableClass(el, variantAvailability == "true")
    })

    options.querySelectorAll(`[data-option-number='3'] .option-value`).forEach(el => {
      optionValue = el.getAttribute("data-option-value")
      variantId = getVariantId(firstActiveOption, secondActiveOption, optionValue)
      variantAvailability = options.querySelector(`[value='${variantId}']`)?.getAttribute("data-variant-available")
      toggleAvailableClass(el, variantAvailability == "true")
    })
  } else if (productOptionsLength == 2) {
    options.querySelectorAll(`[data-option-number='1'] .option-value`).forEach(el => {
      optionValue = el.getAttribute("data-option-value")
      variantId = getVariantId(optionValue, secondActiveOption)
      variantAvailability = options.querySelector(`[value='${variantId}']`)?.getAttribute("data-variant-available")
      toggleAvailableClass(el, variantAvailability == "true")
    })

    options.querySelectorAll(`[data-option-number='2'] .option-value`).forEach(el => {
      optionValue = el.getAttribute("data-option-value")
      variantId = getVariantId(firstActiveOption, optionValue)
      variantAvailability = options.querySelector(`[value='${variantId}']`)?.getAttribute("data-variant-available")
      toggleAvailableClass(el, variantAvailability == "true")
    })
  } else {
    options.querySelectorAll(`[data-option-number='1'] .option-value`).forEach(el => {
      optionValue = el.getAttribute("data-option-value")
      variantId = getVariantId(optionValue)
      variantAvailability = options.querySelector(`[value='${variantId}']`)?.getAttribute("data-variant-available")
      toggleAvailableClass(el, variantAvailability == "true")
    })
  }
}

function toggleAvailableClass(el, available) {
  if (available) {
    el.classList.remove("unavailable")
    el.removeAttribute("disabled")
  } else {
    el.classList.add("unavailable")
    el.setAttribute("disabled", "")
  }
}

function getActiveOptionName(index) {
  let activeOptionName

  if (options.querySelector(`[data-option-number='${index}']`) == null) return null

  activeOptionName = options.querySelector(`[data-option-number='${index}'] .option-values`).getAttribute("data-active-option")

  return activeOptionName
}

function updateProductData() {
  let id = getVariantId()
  let newPrice = options.querySelector(`[value='${id}']`).getAttribute("data-variant-price")
  let newComparePrice = options.querySelector(`[value='${id}']`).getAttribute("data-variant-compare")
  let newAvailability = options.querySelector(`[value='${id}']`).getAttribute("data-variant-available")

  if (newComparePrice != "") document.querySelector(".product-compare").classList.remove("c-h")
  else document.querySelector(".product-compare").classList.add("c-h")

  document.querySelector(".product-compare").textContent = newComparePrice
  document.querySelector(".product-price").textContent = newPrice
  document.querySelector(".product-button.atc span").textContent = newPrice

  /*if(newAvailability == "true") {
    document.querySelector(".product-button.atc").classList.remove("c-h")
    document.querySelector(".product-button.oos").classList.add("c-h")
  } else {
    document.querySelector(".product-button.atc").classList.add("c-h")
    document.querySelector(".product-button.oos").classList.remove("c-h")
  }*/
}

const skuForVariant = (id) => window.ShopifyAnalytics.meta.product.variants.find(v => v.id == id)['sku']

function changeSelectedVariant() {
  const odijKitLink = document.querySelector('#odij-kit-link')
  if (odijKitLink) {
    odijKitLink.href = `/pages/kit-essai-couche-pharmacies?sku=${skuForVariant(getVariantId())}`
  }
  options.querySelector(".product-variants__select").value = getVariantId()
}

function updateImage() {
  let id = getVariantId()
  let newImageId = options.querySelector(`[value='${id}']`).getAttribute("data-variant-image")
  let targetImage = document.querySelector(`[data-pi-id='${newImageId}']`)
  if (targetImage != null) {
    let targetIndex = targetImage.parentElement.getAttribute("data-pi-index")
    slideToProductImage(targetIndex)
    setCurrentActiveProductImage(targetIndex)
  }
}

async function addToJooneCart() {
  document.querySelector(".s-header .cart .number").classList.remove("c-h")

  //await addVariantToCart(getVariantId(), 1)

  // Rafraichir l'incentive cart

  /*if (document.querySelector("#incentive-cart-popin") != null) document.querySelector("#incentive-cart-popin").style.display = "block"
  else if (document.querySelector("#incentive-cart-slide") != null) document.querySelector("#incentive-cart-slide").style.display = "block"
  else return console.log("No cart loaded on the page")*/
}

/*function addVariantToCart(id, quantity) {
  return new Promise(resolve => {
    let change = JSON.stringify({ 'id': id.toString(), 'quantity': quantity.toString() })

    let xhr = new XMLHttpRequest()

    xhr.onreadystatechange = function() { if (this.readyState == 4 && this.status == 200) resolve() }

    xhr.open("POST", "/cart/add.js", true)
    xhr.setRequestHeader("Content-Type", "application/json")
    xhr.send(change)
  })
}

function getCart() {
  return new Promise(resolve => {
    let xhr = new XMLHttpRequest()

    xhr.onreadystatechange = function() { if (this.readyState == 4 && this.status == 200) resolve() }

    xhr.open("GET", "/cart.js", true)
    xhr.send()
  })
}*/

document.querySelector('.product-options .button-wrapper').addEventListener('click', (event) => {
  event.preventDefault();

  const section = document.querySelector('.product-options .button-wrapper');

  const clickEventPath = event.composedPath().slice(0, -2);

  for (const element of clickEventPath) {
    if (element.classList.contains('first')) {
      oneShotClickHandler(element, section);
      break;
    } else if (element.classList.contains('second')) {
      subscriptionClickHandler(element, section);
      break;
    }
  }
})

const oneShotClickHandler = (element, section) => {
  const oldButton = document.querySelector(`[data-option-value="Acheter une fois"]`);

  const clickEvent = new MouseEvent('click', {
    view: window,
    bubbles: true,
    cancelable: true
  });

  oldButton.dispatchEvent(clickEvent);

  section.querySelector('.button-container[data-active]').removeAttribute('data-active');
  section.querySelector('.button-container.first').setAttribute('data-active', '');
}

const subscriptionClickHandler = (element, section) => {
  const oldButton = document.querySelector(`[data-option-value="S'abonner"]`);

  const clickEvent = new MouseEvent('click', {
    view: window,
    bubbles: true,
    cancelable: true
  });

  oldButton.dispatchEvent(clickEvent);

  section.querySelector('.button-container[data-active]').removeAttribute('data-active');
  section.querySelector('.button-container.second').setAttribute('data-active', '');
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s-product-couche-origine-v2"] && !window.DesignMode) return;
  try {
    

// Variables globales
let options = document.querySelector(".product-options")

// Miniature image clicks
document.querySelectorAll(".product-miniature").forEach(el => {
  el.addEventListener("click", e => {
    // On récupère l'identifiant de la miniature
    let miniatureId = e.currentTarget.children[0].getAttribute("data-pm-id")
    // On trouve l'image correspondante
    let targetImage = document.querySelector(`[data-pi-id='${miniatureId}']`)
    // On récupère l'index de l'image
    let targetIndex = targetImage.parentElement.getAttribute("data-pi-index")
    // On met à jour l'image
    slideToProductImage(targetIndex)
    // On indique que le focus est sur cette image
    setCurrentActiveProductImage(targetIndex)
  })
})

// Product option clicks
document.querySelectorAll(".option-value").forEach(el => {
  el.addEventListener("click", e => {
    // Si l'option n'est pas disponible, ne rien faire
    if (e.currentTarget.classList.contains("unavailable")) return
    // On récupère la nouvelle option
    let newOption = e.currentTarget.getAttribute("data-option-value")
    // On met à jour visuellement les options actives
    changeSelectedOption(e.currentTarget.parentElement, newOption)
    // On met à jour les choix d'options disponibles
    updateOptionsAvailability()
    // On met à jour les infos produits
    updateProductData()
    // On met à jour la variante dans le master select
    changeSelectedVariant()
    // On met à jour l'image
    // updateImage()
  })
})

// Scroll options (Desktop)
document.querySelectorAll(".product-option").forEach(el => {
  let numberOfOptions = parseInt(el.getAttribute("data-option-size"))
  if (window.screen.width > 1200 && numberOfOptions > 3) {
    el.querySelector(".option-values").addEventListener("wheel", e => {
      e.preventDefault()
      el.querySelector(".option-values").scrollLeft += 100 * e.deltaY / Math.abs(e.deltaY)
    })
  }
})

// Carousel arrow clicks
document.querySelectorAll(".option-value__arrow").forEach(el => {
  el.addEventListener("click", e => {
    let optionValues = el.parentElement.previousElementSibling
    if (el.classList.contains("previous")) optionValues.scroll({left: optionValues.scrollLeft - 100, behavior: 'smooth'})
    else {
      optionValues.scroll({top: 0, left: optionValues.scrollLeft + 100, behavior: 'smooth'})
      el.previousElementSibling.classList.remove("c-h")
    }
  })
})


document.querySelectorAll(".product-miniature__arrow").forEach(el => {
  el.addEventListener("click", e => {
    let miniatures = el.parentElement.previousElementSibling
    if (el.classList.contains("previous")) miniatures.scroll({top: miniatures.scrollTop - 100, behavior: 'smooth'})
    else miniatures.scroll({top: miniatures.scrollTop + 100, left: 0, behavior: 'smooth'})
  })
})

// Add to cart click
document.querySelector(".product-button.atc").addEventListener("click", e => addToJooneCart())


// Helper functions
function slideToProductImage(index) {
  // Si l'image n'est pas accessible, ne rien faire
  if (document.querySelector(`.product-image.index-${index}`) == null) return
  // Sinon, faire scroller le slider jusqu'à l'image
  document.querySelector(`.product-image.index-${index}`).scrollIntoView({ behavior: 'smooth', block: 'nearest' })
}

function setCurrentActiveProductImage(index) {
  // Si l'image n'est pas accessible, ne rien faire
  if (document.querySelector(`.product-image.index-${index}`) == null) return
  // Sinon, mettre à jour l'image active dans les données HTML
  document.querySelector(".product-images").setAttribute("data-active-index", index)
}


function slideToProductMiniature(index) {
  if (document.querySelector(`.product-miniature.index-${index}`) == null) return
  document.querySelector(`.product-miniature.index-${index}`).scrollIntoView({ behavior: 'smooth', block: 'nearest' })
}

function setCurrentActiveProductMiniature(index) {
  if (document.querySelector(`.product-miniature.index-${index}`) == null) return
  document.querySelector(".product-miniatures").setAttribute("data-active-index", index)
}

function changeSelectedOption(el, value) {
  // On met à jour l'option active dans les données HTML
  el.setAttribute("data-active-option", value)
  // On retire la bordure verte de l'option active précédente
  el.querySelector(".option-value.active").classList.remove("active")
  // On applique la bordure verte pour la nouvelle option active
  el.querySelector(`[data-option-value="${value}"]`).classList.add("active")
}

function getVariantId(firstOption, secondOption, thirdOption) {
  let variantName, variantId
  variantName = getVariantName(firstOption, secondOption, thirdOption)

  variantId = document.querySelector(`[data-variant-title="${variantName}"]`)?.getAttribute("value")
  return variantId
}

function getVariantName(firstOption, secondOption, thirdOption) {

  if (thirdOption == null && options.querySelector("[data-option-number='3']") != null) {
    thirdOption = options.querySelector("[data-option-number='3'] .option-values").getAttribute("data-active-option")
  }

  if (secondOption == null && options.querySelector("[data-option-number='2']") != null) {
    secondOption = options.querySelector("[data-option-number='2'] .option-values").getAttribute("data-active-option")
  }

  if (firstOption == null && options.querySelector("[data-option-number='1']") != null) {
    firstOption = options.querySelector("[data-option-number='1'] .option-values").getAttribute("data-active-option")
  }

  if (thirdOption != null) {
    variantName = firstOption + " / " + secondOption + " / " + thirdOption
  } else if (secondOption != null) {
    variantName = firstOption + " / " + secondOption
  } else {
    variantName = firstOption
  }

  return variantName
}

function updateOptionsAvailability() {
  let optionValue, variantId, variantAvailability
  let productOptionsLength
  let firstActiveOption = getActiveOptionName(1)
  let secondActiveOption = getActiveOptionName(2)
  let thirdActiveOption = getActiveOptionName(3)

  if (thirdActiveOption != null) {
    productOptionsLength = 3
  } else if (secondActiveOption != null) {
    productOptionsLength = 2
  } else {
    productOptionsLength = 1
  }

  if (productOptionsLength == 3) {
    options.querySelectorAll(`[data-option-number='1'] .option-value`).forEach(el => {
      optionValue = el.getAttribute("data-option-value")

      variantId = getVariantId(optionValue, secondActiveOption, thirdActiveOption)
      variantAvailability = options.querySelector(`[value='${variantId}']`)?.getAttribute("data-variant-available")
      toggleAvailableClass(el, variantAvailability == "true")
    })

    options.querySelectorAll(`[data-option-number='2'] .option-value`).forEach(el => {
      optionValue = el.getAttribute("data-option-value")
      variantId = getVariantId(firstActiveOption, optionValue, thirdActiveOption)
      variantAvailability = options.querySelector(`[value='${variantId}']`)?.getAttribute("data-variant-available")
      toggleAvailableClass(el, variantAvailability == "true")
    })

    options.querySelectorAll(`[data-option-number='3'] .option-value`).forEach(el => {
      optionValue = el.getAttribute("data-option-value")
      variantId = getVariantId(firstActiveOption, secondActiveOption, optionValue)
      variantAvailability = options.querySelector(`[value='${variantId}']`)?.getAttribute("data-variant-available")
      toggleAvailableClass(el, variantAvailability == "true")
    })
  } else if (productOptionsLength == 2) {
    options.querySelectorAll(`[data-option-number='1'] .option-value`).forEach(el => {
      optionValue = el.getAttribute("data-option-value")
      variantId = getVariantId(optionValue, secondActiveOption)
      variantAvailability = options.querySelector(`[value='${variantId}']`)?.getAttribute("data-variant-available")
      toggleAvailableClass(el, variantAvailability == "true")
    })

    options.querySelectorAll(`[data-option-number='2'] .option-value`).forEach(el => {
      optionValue = el.getAttribute("data-option-value")
      variantId = getVariantId(firstActiveOption, optionValue)
      variantAvailability = options.querySelector(`[value='${variantId}']`)?.getAttribute("data-variant-available")
      toggleAvailableClass(el, variantAvailability == "true")
    })
  } else {
    options.querySelectorAll(`[data-option-number='1'] .option-value`).forEach(el => {
      optionValue = el.getAttribute("data-option-value")
      variantId = getVariantId(optionValue)
      variantAvailability = options.querySelector(`[value='${variantId}']`)?.getAttribute("data-variant-available")
      toggleAvailableClass(el, variantAvailability == "true")
    })
  }
}

function toggleAvailableClass(el, available) {
  if (available) {
    el.classList.remove("unavailable")
    el.removeAttribute("disabled")
  } else {
    el.classList.add("unavailable")
    el.setAttribute("disabled", "")
  }
}

function getActiveOptionName(index) {
  let activeOptionName

  if (options.querySelector(`[data-option-number='${index}']`) == null) return null

  activeOptionName = options.querySelector(`[data-option-number='${index}'] .option-values`).getAttribute("data-active-option")

  return activeOptionName
}

function updateProductData() {
  let id = getVariantId()
  let newPrice = options.querySelector(`[value='${id}']`).getAttribute("data-variant-price")
  let newComparePrice = options.querySelector(`[value='${id}']`).getAttribute("data-variant-compare")
  let newAvailability = options.querySelector(`[value='${id}']`).getAttribute("data-variant-available")

  if (newComparePrice != "") document.querySelector(".product-compare").classList.remove("c-h")
  else document.querySelector(".product-compare").classList.add("c-h")

  document.querySelector(".product-compare").textContent = newComparePrice
  document.querySelector(".product-price").textContent = newPrice
  document.querySelector(".product-button.atc span").textContent = newPrice

  /*if(newAvailability == "true") {
    document.querySelector(".product-button.atc").classList.remove("c-h")
    document.querySelector(".product-button.oos").classList.add("c-h")
  } else {
    document.querySelector(".product-button.atc").classList.add("c-h")
    document.querySelector(".product-button.oos").classList.remove("c-h")
  }*/
}

const skuForVariant = (id) => window.ShopifyAnalytics.meta.product.variants.find(v => v.id == id)['sku']

function changeSelectedVariant() {
  const odijKitLink = document.querySelector('#odij-kit-link')
  if (odijKitLink) {
    odijKitLink.href = `/pages/kit-essai-couche-pharmacies?sku=${skuForVariant(getVariantId())}`
  }
  options.querySelector(".product-variants__select").value = getVariantId()
}

function updateImage() {
  let id = getVariantId()
  let newImageId = options.querySelector(`[value='${id}']`).getAttribute("data-variant-image")
  let targetImage = document.querySelector(`[data-pi-id='${newImageId}']`)
  if (targetImage != null) {
    let targetIndex = targetImage.parentElement.getAttribute("data-pi-index")
    slideToProductImage(targetIndex)
    setCurrentActiveProductImage(targetIndex)
  }
}

async function addToJooneCart() {
  document.querySelector(".s-header .cart .number").classList.remove("c-h")

  //await addVariantToCart(getVariantId(), 1)

  // Rafraichir l'incentive cart

  /*if (document.querySelector("#incentive-cart-popin") != null) document.querySelector("#incentive-cart-popin").style.display = "block"
  else if (document.querySelector("#incentive-cart-slide") != null) document.querySelector("#incentive-cart-slide").style.display = "block"
  else return console.log("No cart loaded on the page")*/
}

/*function addVariantToCart(id, quantity) {
  return new Promise(resolve => {
    let change = JSON.stringify({ 'id': id.toString(), 'quantity': quantity.toString() })

    let xhr = new XMLHttpRequest()

    xhr.onreadystatechange = function() { if (this.readyState == 4 && this.status == 200) resolve() }

    xhr.open("POST", "/cart/add.js", true)
    xhr.setRequestHeader("Content-Type", "application/json")
    xhr.send(change)
  })
}

function getCart() {
  return new Promise(resolve => {
    let xhr = new XMLHttpRequest()

    xhr.onreadystatechange = function() { if (this.readyState == 4 && this.status == 200) resolve() }

    xhr.open("GET", "/cart.js", true)
    xhr.send()
  })
}*/

document.querySelector('.product-options .button-wrapper').addEventListener('click', (event) => {
  event.preventDefault();

  const section = document.querySelector('.product-options .button-wrapper');

  const clickEventPath = event.composedPath().slice(0, -2);

  for (const element of clickEventPath) {
    if (element.classList.contains('first')) {
      oneShotClickHandler(element, section);
      break;
    } else if (element.classList.contains('second')) {
      subscriptionClickHandler(element, section);
      break;
    }
  }
})

const oneShotClickHandler = (element, section) => {
  const oldButton = document.querySelector(`[data-option-value="Acheter une fois"]`);

  const clickEvent = new MouseEvent('click', {
    view: window,
    bubbles: true,
    cancelable: true
  });

  oldButton.dispatchEvent(clickEvent);

  section.querySelector('.button-container[data-active]').removeAttribute('data-active');
  section.querySelector('.button-container.first').setAttribute('data-active', '');
}

const subscriptionClickHandler = (element, section) => {
  const oldButton = document.querySelector(`[data-option-value="S'abonner"]`);

  const clickEvent = new MouseEvent('click', {
    view: window,
    bubbles: true,
    cancelable: true
  });

  oldButton.dispatchEvent(clickEvent);

  section.querySelector('.button-container[data-active]').removeAttribute('data-active');
  section.querySelector('.button-container.second').setAttribute('data-active', '');
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s-product-couche-origine"] && !window.DesignMode) return;
  try {
    

// Variables globales
let options = document.querySelector(".product-options")

// Miniature image clicks
document.querySelectorAll(".product-miniature").forEach(el => {
  el.addEventListener("click", e => {
    // On récupère l'identifiant de la miniature
    let miniatureId = e.currentTarget.children[0].getAttribute("data-pm-id")
    // On trouve l'image correspondante
    let targetImage = document.querySelector(`[data-pi-id='${miniatureId}']`)
    // On récupère l'index de l'image
    let targetIndex = targetImage.parentElement.getAttribute("data-pi-index")
    // On met à jour l'image
    slideToProductImage(targetIndex)
    // On indique que le focus est sur cette image
    setCurrentActiveProductImage(targetIndex)
  })
})

// Product option clicks
document.querySelectorAll(".option-value").forEach(el => {
  el.addEventListener("click", e => {
    // Si l'option n'est pas disponible, ne rien faire
    if (e.currentTarget.classList.contains("unavailable")) return
    // On récupère la nouvelle option
    let newOption = e.currentTarget.getAttribute("data-option-value")
    // On met à jour visuellement les options actives
    changeSelectedOption(e.currentTarget.parentElement, newOption)
    // On met à jour les choix d'options disponibles
    updateOptionsAvailability()
    // On met à jour les infos produits
    updateProductData()
    // On met à jour la variante dans le master select
    changeSelectedVariant()
    // On met à jour l'image
    // updateImage()
  })
})

// Scroll options (Desktop)
document.querySelectorAll(".product-option").forEach(el => {
  let numberOfOptions = parseInt(el.getAttribute("data-option-size"))
  if (window.screen.width > 1200 && numberOfOptions > 3) {
    el.querySelector(".option-values").addEventListener("wheel", e => {
      e.preventDefault()
      el.querySelector(".option-values").scrollLeft += 100 * e.deltaY / Math.abs(e.deltaY)
    })
  }
})

// Carousel arrow clicks
document.querySelectorAll(".option-value__arrow").forEach(el => {
  el.addEventListener("click", e => {
    let optionValues = el.parentElement.previousElementSibling
    if (el.classList.contains("previous")) optionValues.scroll({left: optionValues.scrollLeft - 100, behavior: 'smooth'})
    else {
      optionValues.scroll({top: 0, left: optionValues.scrollLeft + 100, behavior: 'smooth'})
      el.previousElementSibling.classList.remove("c-h")
    }
  })
})


document.querySelectorAll(".product-miniature__arrow").forEach(el => {
  el.addEventListener("click", e => {
    let miniatures = el.parentElement.previousElementSibling
    if (el.classList.contains("previous")) miniatures.scroll({top: miniatures.scrollTop - 100, behavior: 'smooth'})
    else miniatures.scroll({top: miniatures.scrollTop + 100, left: 0, behavior: 'smooth'})
  })
})

// Add to cart click
document.querySelector(".product-button.atc").addEventListener("click", e => addToJooneCart())


// Helper functions
function slideToProductImage(index) {
  // Si l'image n'est pas accessible, ne rien faire
  if (document.querySelector(`.product-image.index-${index}`) == null) return
  // Sinon, faire scroller le slider jusqu'à l'image
  document.querySelector(`.product-image.index-${index}`).scrollIntoView({ behavior: 'smooth', block: 'nearest' })
}

function setCurrentActiveProductImage(index) {
  // Si l'image n'est pas accessible, ne rien faire
  if (document.querySelector(`.product-image.index-${index}`) == null) return
  // Sinon, mettre à jour l'image active dans les données HTML
  document.querySelector(".product-images").setAttribute("data-active-index", index)
}


function slideToProductMiniature(index) {
  if (document.querySelector(`.product-miniature.index-${index}`) == null) return
  document.querySelector(`.product-miniature.index-${index}`).scrollIntoView({ behavior: 'smooth', block: 'nearest' })
}

function setCurrentActiveProductMiniature(index) {
  if (document.querySelector(`.product-miniature.index-${index}`) == null) return
  document.querySelector(".product-miniatures").setAttribute("data-active-index", index)
}

function changeSelectedOption(el, value) {
  // On met à jour l'option active dans les données HTML
  el.setAttribute("data-active-option", value)
  // On retire la bordure verte de l'option active précédente
  el.querySelector(".option-value.active").classList.remove("active")
  // On applique la bordure verte pour la nouvelle option active
  el.querySelector(`[data-option-value="${value}"]`).classList.add("active")
}

function getVariantId(firstOption, secondOption, thirdOption) {
  let variantName, variantId
  variantName = getVariantName(firstOption, secondOption, thirdOption)

  variantId = document.querySelector(`[data-variant-title="${variantName}"]`)?.getAttribute("value")
  return variantId
}

function getVariantName(firstOption, secondOption, thirdOption) {

  if (thirdOption == null && options.querySelector("[data-option-number='3']") != null) {
    thirdOption = options.querySelector("[data-option-number='3'] .option-values").getAttribute("data-active-option")
  }

  if (secondOption == null && options.querySelector("[data-option-number='2']") != null) {
    secondOption = options.querySelector("[data-option-number='2'] .option-values").getAttribute("data-active-option")
  }

  if (firstOption == null && options.querySelector("[data-option-number='1']") != null) {
    firstOption = options.querySelector("[data-option-number='1'] .option-values").getAttribute("data-active-option")
  }

  if (thirdOption != null) {
    variantName = firstOption + " / " + secondOption + " / " + thirdOption
  } else if (secondOption != null) {
    variantName = firstOption + " / " + secondOption
  } else {
    variantName = firstOption
  }

  return variantName
}

function updateOptionsAvailability() {
  let optionValue, variantId, variantAvailability
  let productOptionsLength
  let firstActiveOption = getActiveOptionName(1)
  let secondActiveOption = getActiveOptionName(2)
  let thirdActiveOption = getActiveOptionName(3)

  if (thirdActiveOption != null) {
    productOptionsLength = 3
  } else if (secondActiveOption != null) {
    productOptionsLength = 2
  } else {
    productOptionsLength = 1
  }

  if (productOptionsLength == 3) {
    options.querySelectorAll(`[data-option-number='1'] .option-value`).forEach(el => {
      optionValue = el.getAttribute("data-option-value")

      variantId = getVariantId(optionValue, secondActiveOption, thirdActiveOption)
      variantAvailability = options.querySelector(`[value='${variantId}']`)?.getAttribute("data-variant-available")
      toggleAvailableClass(el, variantAvailability == "true")
    })

    options.querySelectorAll(`[data-option-number='2'] .option-value`).forEach(el => {
      optionValue = el.getAttribute("data-option-value")
      variantId = getVariantId(firstActiveOption, optionValue, thirdActiveOption)
      variantAvailability = options.querySelector(`[value='${variantId}']`)?.getAttribute("data-variant-available")
      toggleAvailableClass(el, variantAvailability == "true")
    })

    options.querySelectorAll(`[data-option-number='3'] .option-value`).forEach(el => {
      optionValue = el.getAttribute("data-option-value")
      variantId = getVariantId(firstActiveOption, secondActiveOption, optionValue)
      variantAvailability = options.querySelector(`[value='${variantId}']`)?.getAttribute("data-variant-available")
      toggleAvailableClass(el, variantAvailability == "true")
    })
  } else if (productOptionsLength == 2) {
    options.querySelectorAll(`[data-option-number='1'] .option-value`).forEach(el => {
      optionValue = el.getAttribute("data-option-value")
      variantId = getVariantId(optionValue, secondActiveOption)
      variantAvailability = options.querySelector(`[value='${variantId}']`)?.getAttribute("data-variant-available")
      toggleAvailableClass(el, variantAvailability == "true")
    })

    options.querySelectorAll(`[data-option-number='2'] .option-value`).forEach(el => {
      optionValue = el.getAttribute("data-option-value")
      variantId = getVariantId(firstActiveOption, optionValue)
      variantAvailability = options.querySelector(`[value='${variantId}']`)?.getAttribute("data-variant-available")
      toggleAvailableClass(el, variantAvailability == "true")
    })
  } else {
    options.querySelectorAll(`[data-option-number='1'] .option-value`).forEach(el => {
      optionValue = el.getAttribute("data-option-value")
      variantId = getVariantId(optionValue)
      variantAvailability = options.querySelector(`[value='${variantId}']`)?.getAttribute("data-variant-available")
      toggleAvailableClass(el, variantAvailability == "true")
    })
  }
}

function toggleAvailableClass(el, available) {
  if (available) {
    el.classList.remove("unavailable")
    el.removeAttribute("disabled")
  } else {
    el.classList.add("unavailable")
    el.setAttribute("disabled", "")
  }
}

function getActiveOptionName(index) {
  let activeOptionName

  if (options.querySelector(`[data-option-number='${index}']`) == null) return null

  activeOptionName = options.querySelector(`[data-option-number='${index}'] .option-values`).getAttribute("data-active-option")

  return activeOptionName
}

function updateProductData() {
  let id = getVariantId()
  let newPrice = options.querySelector(`[value='${id}']`).getAttribute("data-variant-price")
  let newComparePrice = options.querySelector(`[value='${id}']`).getAttribute("data-variant-compare")
  let newAvailability = options.querySelector(`[value='${id}']`).getAttribute("data-variant-available")

  if (newComparePrice != "") document.querySelector(".product-compare").classList.remove("c-h")
  else document.querySelector(".product-compare").classList.add("c-h")

  document.querySelector(".product-compare").textContent = newComparePrice
  document.querySelector(".product-price").textContent = newPrice
  document.querySelector(".product-button.atc span").textContent = newPrice

  /*if(newAvailability == "true") {
    document.querySelector(".product-button.atc").classList.remove("c-h")
    document.querySelector(".product-button.oos").classList.add("c-h")
  } else {
    document.querySelector(".product-button.atc").classList.add("c-h")
    document.querySelector(".product-button.oos").classList.remove("c-h")
  }*/
}

const skuForVariant = (id) => window.ShopifyAnalytics.meta.product.variants.find(v => v.id == id)['sku']

function changeSelectedVariant() {
  const odijKitLink = document.querySelector('#odij-kit-link')
  if (odijKitLink) {
    odijKitLink.href = `/pages/kit-essai-couche-pharmacies?sku=${skuForVariant(getVariantId())}`
  }
  options.querySelector(".product-variants__select").value = getVariantId()
}

function updateImage() {
  let id = getVariantId()
  let newImageId = options.querySelector(`[value='${id}']`).getAttribute("data-variant-image")
  let targetImage = document.querySelector(`[data-pi-id='${newImageId}']`)
  if (targetImage != null) {
    let targetIndex = targetImage.parentElement.getAttribute("data-pi-index")
    slideToProductImage(targetIndex)
    setCurrentActiveProductImage(targetIndex)
  }
}

async function addToJooneCart() {
  document.querySelector(".s-header .cart .number").classList.remove("c-h")

  //await addVariantToCart(getVariantId(), 1)

  // Rafraichir l'incentive cart

  /*if (document.querySelector("#incentive-cart-popin") != null) document.querySelector("#incentive-cart-popin").style.display = "block"
  else if (document.querySelector("#incentive-cart-slide") != null) document.querySelector("#incentive-cart-slide").style.display = "block"
  else return console.log("No cart loaded on the page")*/
}

/*function addVariantToCart(id, quantity) {
  return new Promise(resolve => {
    let change = JSON.stringify({ 'id': id.toString(), 'quantity': quantity.toString() })

    let xhr = new XMLHttpRequest()

    xhr.onreadystatechange = function() { if (this.readyState == 4 && this.status == 200) resolve() }

    xhr.open("POST", "/cart/add.js", true)
    xhr.setRequestHeader("Content-Type", "application/json")
    xhr.send(change)
  })
}

function getCart() {
  return new Promise(resolve => {
    let xhr = new XMLHttpRequest()

    xhr.onreadystatechange = function() { if (this.readyState == 4 && this.status == 200) resolve() }

    xhr.open("GET", "/cart.js", true)
    xhr.send()
  })
}*/

document.querySelector('.product-options .button-wrapper').addEventListener('click', (event) => {
  event.preventDefault();

  const section = document.querySelector('.product-options .button-wrapper');

  const clickEventPath = event.composedPath().slice(0, -2);

  for (const element of clickEventPath) {
    if (element.classList.contains('first')) {
      oneShotClickHandler(element, section);
      break;
    } else if (element.classList.contains('second')) {
      subscriptionClickHandler(element, section);
      break;
    }
  }
})

const oneShotClickHandler = (element, section) => {
  const oldButton = document.querySelector(`[data-option-value="Acheter une fois"]`);

  const clickEvent = new MouseEvent('click', {
    view: window,
    bubbles: true,
    cancelable: true
  });

  oldButton.dispatchEvent(clickEvent);

  section.querySelector('.button-container[data-active]').removeAttribute('data-active');
  section.querySelector('.button-container.first').setAttribute('data-active', '');
}

const subscriptionClickHandler = (element, section) => {
  const oldButton = document.querySelector(`[data-option-value="S'abonner"]`);

  const clickEvent = new MouseEvent('click', {
    view: window,
    bubbles: true,
    cancelable: true
  });

  oldButton.dispatchEvent(clickEvent);

  section.querySelector('.button-container[data-active]').removeAttribute('data-active');
  section.querySelector('.button-container.second').setAttribute('data-active', '');
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s-product-diaper-bundle"] && !window.DesignMode) return;
  try {
    
  document.addEventListener("diapersFetched", (event) => {
    subscriptionDiapersProducts = deducedPrintsFromProductPage(event.detail);
    showSection();
    dispatchAvailabilitiesEventListeners()
    clickFirstSize()
    configureAddToCartBundle()
  });

  const clickFirstSize = () => {
    const sizeContainer = optionsValuesContainers()[0]
    const sizeListItems = sizeContainer.querySelectorAll("li.joone-product-selector.option-value");

    const clickEvent = new MouseEvent('click', {
      view: window,
      bubbles: true,
      cancelable: true
    });
    sizeListItems[0].dispatchEvent(clickEvent);
  }

  const productOptionValues = () => document.querySelectorAll('.option-value')
  const dispatchAvailabilitiesEventListeners = () => {
    productOptionValues().forEach((productOption) => {
      productOption.addEventListener('click', checkAvailability)
    })
  }

  const unavailableSizes = (printName) => {
  }

  const unavailablePrintName = (size) => {
  }

  const capitalize = (string) => {
    return string?.[0]?.toUpperCase() + string?.slice(1) || "";
  }

  const checkAvailability = () => {
    // TODO: overselling
    const unavailableVariants = subscriptionDiapersProducts.reduce((accumulator, subscriptionDiaperProduct) => {
      const unavailableVariant = subscriptionDiaperProduct.variants.find(subscriptionDiaperVariant => {
        return subscriptionDiaperVariant.size === activeSize() &&
          subscriptionDiaperVariant.quantity <= 50;
      })

      if (unavailableVariant) {
        accumulator.push(unavailableVariant)
      }
      return accumulator;
    }, [])

    for (let unavailableVariant of unavailableVariants) {
      const unavailablePrintElement = document.querySelector(`li.joone-product-selector.option-value[data-option-value="${capitalize(unavailableVariant.printName)}"]`)
      unavailablePrintElement.classList.add('unavailable')
    }

    if (activeVariant().quantityAvailable <= 50) {
      addToCartBtns().forEach(btn => blockAddToCart(btn, 'Sold Out'))
    } else {
      addToCartBtns().forEach(btn => unBlockAddToCart(btn, 'Add - €64.90'))
    }
  }

  const activeVariant = () => {
    const diapersProduct = subscriptionDiapersProducts.find(subscriptionDiaperProduct => {
      return subscriptionDiaperProduct.printName === activePrintName()
    })
    const diapersVariant = diapersProduct.variants.find(variant => variant.size === activeSize());
    return diapersVariant;
  }

  const deducedPrintsFromProductPage = (subscriptionDiapersProductFetched) => {
    const subscriptionDiapersProductPrints = productPagePrintsNames().reduce(
      (accumulator, printName) => {
        const productPageVariantPrintFound = subscriptionDiapersProductFetched.find(subscriptionDiaperProduct => {
          return subscriptionDiaperProduct.printName === printName;
        })
        if (productPageVariantPrintFound) accumulator.push(productPageVariantPrintFound);
        return accumulator;
      },
    [])
    return subscriptionDiapersProductPrints;
  }

  const optionsValuesContainers = () => {
    return document.querySelectorAll(".option-values__container");
  }

  const productPageSizes = () => {
    const sizeContainer = optionsValuesContainers()[0]
    const sizeListItems = sizeContainer.querySelectorAll("li.joone-product-selector.option-value");
    const sizes = [...sizeListItems].map(li => li.dataset.optionValue?.slice(0, 2));
    sizeListItems.forEach(sizeListItem => {
        sizeListItem.dataset.optionSize = sizeListItem.dataset.optionValue?.slice(0, 2); // Set the data attribute
    });
    return sizes;
  }

  const productPagePrintsNames = () => {
    const printsContainer = optionsValuesContainers()[1];
    const printsListItems = printsContainer.querySelectorAll("li.joone-product-selector.option-value");
    const prints = [...printsListItems].map(li => li.dataset.optionValue?.toLowerCase());
    const printsNames = prints.filter(print => print);
    return printsNames;
  }

  // variants options hidden by default on content load
  const showSection = () => {
    const variantOptions = document.querySelector('.second-material');
    variantOptions.style.display = '';

    const loadingElement = document.querySelector('#loading')
    loadingElement.style.display = 'none';
  }

  const activeOptions = () => {
    return document.querySelectorAll('.joone-product-selector.option-value.active')
  }

  const activeSizeOption = () => {
    return activeOptions()[0];
  }

  const activeSize = () => {
    return activeOptions()[0].dataset.optionValue.slice(0, 2);
  }

  const activePrint = () => {
    return activeOptions()[1];
  }

  const activePrintName = () => {
    return activeOptions()[1].dataset.optionValue.toLowerCase()
  }

  // Variables globales
  let options = document.querySelector(".product-options")

  // Miniature image clicks
  document.querySelectorAll(".product-miniature").forEach(el => {
    el.addEventListener("click", e => {
      // On récupère l'identifiant de la miniature
      let miniatureId = e.currentTarget.children[0].getAttribute("data-pm-id")
      // On trouve l'image correspondante
      let targetImage = document.querySelector(`[data-pi-id='${miniatureId}']`)
      // On récupère l'index de l'image
      let targetIndex = targetImage.parentElement.getAttribute("data-pi-index")
      // On met à jour l'image
      slideToProductImage(targetIndex)
      // On indique que le focus est sur cette image
      setCurrentActiveProductImage(targetIndex)
    })
  })

  // Product option clicks
  document.querySelectorAll(".option-value").forEach(el => {
    el.addEventListener("click", e => {
      // Si l'option n'est pas disponible, ne rien faire
      if (e.currentTarget.classList.contains("unavailable")) return
      // On récupère la nouvelle option
      let newOption = e.currentTarget.getAttribute("data-option-value")
      // On met à jour visuellement les options actives
      changeSelectedOption(e.currentTarget.parentElement, newOption)
      // On met à jour les choix d'options disponibles
      updateOptionsAvailability()
      // On met à jour les infos produits
      //updateProductData()
      // On met à jour la variante dans le master select
      // changeSelectedVariant()
      // On met à jour l'image
      updateImage()
    })
  })

  // Scroll options (Desktop)
  document.querySelectorAll(".product-option").forEach(el => {
    let numberOfOptions = parseInt(el.getAttribute("data-option-size"))
    if (window.screen.width > 1200 && numberOfOptions > 3) {
      el.querySelector(".option-values").addEventListener("wheel", e => {
        e.preventDefault()
        el.querySelector(".option-values").scrollLeft += 100 * e.deltaY / Math.abs(e.deltaY)
      })
    }
  })

  // Carousel arrow clicks
  document.querySelectorAll(".option-value__arrow").forEach(el => {
    el.addEventListener("click", e => {
      let optionValues = el.parentElement.previousElementSibling
      if (el.classList.contains("previous")) optionValues.scroll({left: optionValues.scrollLeft - 100, behavior: 'smooth'})
      else {
        optionValues.scroll({top: 0, left: optionValues.scrollLeft + 100, behavior: 'smooth'})
        el.previousElementSibling.classList.remove("c-h")
      }
    })
  })


  document.querySelectorAll(".product-miniature__arrow").forEach(el => {
    el.addEventListener("click", e => {
      let miniatures = el.parentElement.previousElementSibling
      if (el.classList.contains("previous")) miniatures.scroll({top: miniatures.scrollTop - 100, behavior: 'smooth'})
      else miniatures.scroll({top: miniatures.scrollTop + 100, left: 0, behavior: 'smooth'})
    })
  })

  const addToCartBtns = () => document.querySelectorAll('.add_to_cart')

  const blockAddToCart = (btn, message = '') => {
    btn.disabled = true
    btn.classList.add('disabled')
    let btnText = btn.querySelector('p').innerHTML = message
    if (message !== '' && btnText) {
      btnText.innerHTML = message
    }
  }
  const unBlockAddToCart = (btn, message) => {
    btn.disabled = false
    btn.classList.remove('disabled')
    let btnText = btn.querySelector('p').innerHTML = message
  }

  const bundleCart = () => {
    const bundleShopifyVariantId = 30374269190241;
    const printShopifyVariantId = activeVariant().id;

    const bundleParts = {
      '_bundle_part_0': printShopifyVariantId,
      '_bundle_part_1': printShopifyVariantId,
      '_bundle_part_2': printShopifyVariantId,
    }
    const bundleProperties = {
      '_source': `oneclicksub_${window.location.pathname}`,
      '_prints': `3x ${activeVariant().displayTitle}`,
      '_interval_count': 30,
      '_interval': 'day',
      ...bundleParts
    }
    const payload = {
      quantity: 1,
      id: bundleShopifyVariantId, // bundle shopify_variant_id JOONECHARGE.BUNDLE.C.V1
      properties: bundleProperties
    }

    return payload;
  }

  async function configureAddToCartBundle() {
    addToCartBtns().forEach((button) => {
      button.addEventListener('click', event => {
        event.preventDefault()
        event.stopPropagation()

        blockAddToCart(button)

        let cart = ''
        if (typeof activeVariant() !== 'undefined') {
          cart = bundleCart()
        } else {
          const form = button.closest('.product_form')
          const formData = new FormData(form)
          const formParams = new URLSearchParams(formData)
          cart = Object.fromEntries(formParams)
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          credentials: 'same-origin',
          responseType: 'json',
          body: JSON.stringify(cart)
        })
        .then(response => response.json())
        .then(data => {
          // const launchIncentiveCartPopin = new CustomEvent('launchIncentiveCartPopin', {
          //   detail: {
          //     variantId: json.variant_id
          //   }
          // })
          // window.dispatchEvent(launchIncentiveCartPopin)
          window.location.href = '/cart'
          // unBlockAddToCart(button)
          // document.querySelector('#incentive-cart-popin').style.display = 'flex'
        })
        .catch(error => {
          console.log(error)
        })

      })
    })
  }

  // Helper functions
  function slideToProductImage(index) {
    // Si l'image n'est pas accessible, ne rien faire
    if (document.querySelector(`.product-image.index-${index}`) == null) return
    // Sinon, faire scroller le slider jusqu'à l'image
    document.querySelector(`.product-image.index-${index}`).scrollIntoView({ behavior: 'smooth', block: 'nearest' })
  }

  function setCurrentActiveProductImage(index) {
    // Si l'image n'est pas accessible, ne rien faire
    if (document.querySelector(`.product-image.index-${index}`) == null) return
    // Sinon, mettre à jour l'image active dans les données HTML
    document.querySelector(".product-images").setAttribute("data-active-index", index)
  }

  function slideToProductMiniature(index) {
    if (document.querySelector(`.product-miniature.index-${index}`) == null) return
    document.querySelector(`.product-miniature.index-${index}`).scrollIntoView({ behavior: 'smooth', block: 'nearest' })
  }

  function setCurrentActiveProductMiniature(index) {
    if (document.querySelector(`.product-miniature.index-${index}`) == null) return
    document.querySelector(".product-miniatures").setAttribute("data-active-index", index)
  }

  function changeSelectedOption(el, value) {
    // On met à jour l'option active dans les données HTML
    el.setAttribute("data-active-option", value)
    // On retire la bordure verte de l'option active précédente
    el.querySelector(".option-value.active").classList.remove("active")
    // On applique la bordure verte pour la nouvelle option active
    el.querySelector(`[data-option-value="${value}"]`).classList.add("active")
  }

  function getVariantId(firstOption, secondOption, thirdOption) {
    let variantName, variantId
    variantName = getVariantName(firstOption, secondOption, thirdOption)

    variantId = document.querySelector(`[data-variant-title="${variantName}"]`)?.getAttribute("value")
    return variantId
  }

  function getVariantName(firstOption, secondOption, thirdOption) {

    if (thirdOption == null && options.querySelector("[data-option-number='3']") != null) {
      thirdOption = options.querySelector("[data-option-number='3'] .option-values").getAttribute("data-active-option")
    }

    if (secondOption == null && options.querySelector("[data-option-number='2']") != null) {
      secondOption = options.querySelector("[data-option-number='2'] .option-values").getAttribute("data-active-option")
    }

    if (firstOption == null && options.querySelector("[data-option-number='1']") != null) {
      firstOption = options.querySelector("[data-option-number='1'] .option-values").getAttribute("data-active-option")
    }

    if (thirdOption != null) {
      variantName = firstOption + " / " + secondOption + " / " + thirdOption
    } else if (secondOption != null) {
      variantName = firstOption + " / " + secondOption
    } else {
      variantName = firstOption
    }

    return variantName
  }

  function updateOptionsAvailability() {
    let optionValue, variantId, variantAvailability
    let productOptionsLength
    let firstActiveOption = getActiveOptionName(1)
    let secondActiveOption = getActiveOptionName(2)
    let thirdActiveOption = getActiveOptionName(3)

    if (thirdActiveOption != null) {
      productOptionsLength = 3
    } else if (secondActiveOption != null) {
      productOptionsLength = 2
    } else {
      productOptionsLength = 1
    }

    if (productOptionsLength == 3) {
      options.querySelectorAll(`[data-option-number='1'] .option-value`).forEach(el => {
        optionValue = el.getAttribute("data-option-value")

        variantId = getVariantId(optionValue, secondActiveOption, thirdActiveOption)
        variantAvailability = options.querySelector(`[value='${variantId}']`)?.getAttribute("data-variant-available")
        toggleAvailableClass(el, variantAvailability == "true")
      })

      options.querySelectorAll(`[data-option-number='2'] .option-value`).forEach(el => {
        optionValue = el.getAttribute("data-option-value")
        variantId = getVariantId(firstActiveOption, optionValue, thirdActiveOption)
        variantAvailability = options.querySelector(`[value='${variantId}']`)?.getAttribute("data-variant-available")
        toggleAvailableClass(el, variantAvailability == "true")
      })

      options.querySelectorAll(`[data-option-number='3'] .option-value`).forEach(el => {
        optionValue = el.getAttribute("data-option-value")
        variantId = getVariantId(firstActiveOption, secondActiveOption, optionValue)
        variantAvailability = options.querySelector(`[value='${variantId}']`)?.getAttribute("data-variant-available")
        toggleAvailableClass(el, variantAvailability == "true")
      })
    } else if (productOptionsLength == 2) {
      options.querySelectorAll(`[data-option-number='1'] .option-value`).forEach(el => {
        optionValue = el.getAttribute("data-option-value")
        variantId = getVariantId(optionValue, secondActiveOption)
        variantAvailability = options.querySelector(`[value='${variantId}']`)?.getAttribute("data-variant-available")
        toggleAvailableClass(el, variantAvailability == "true")
      })

      options.querySelectorAll(`[data-option-number='2'] .option-value`).forEach(el => {
        optionValue = el.getAttribute("data-option-value")
        variantId = getVariantId(firstActiveOption, optionValue)
        variantAvailability = options.querySelector(`[value='${variantId}']`)?.getAttribute("data-variant-available")
        toggleAvailableClass(el, variantAvailability == "true")
      })
    } else {
      options.querySelectorAll(`[data-option-number='1'] .option-value`).forEach(el => {
        optionValue = el.getAttribute("data-option-value")
        variantId = getVariantId(optionValue)
        variantAvailability = options.querySelector(`[value='${variantId}']`)?.getAttribute("data-variant-available")
        toggleAvailableClass(el, variantAvailability == "true")
      })
    }
  }

  function toggleAvailableClass(el, available) {
    if (available) {
      el.classList.remove("unavailable")
      el.removeAttribute("disabled")
    } else {
      el.classList.add("unavailable")
      el.setAttribute("disabled", "")
    }
  }

  function getActiveOptionName(index) {
    let activeOptionName

    if (options.querySelector(`[data-option-number='${index}']`) == null) return null

    activeOptionName = options.querySelector(`[data-option-number='${index}'] .option-values`).getAttribute("data-active-option")

    return activeOptionName
  }

  function updateImage() {
    let id = getVariantId()
    let newImageId = options.querySelector(`[value='${id}']`).getAttribute("data-variant-image")
    let targetImage = document.querySelector(`[data-pi-id='${newImageId}']`)
    if (targetImage != null) {
      let targetIndex = targetImage.parentElement.getAttribute("data-pi-index")
      slideToProductImage(targetIndex)
      setCurrentActiveProductImage(targetIndex)
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s-product"] && !window.DesignMode) return;
  try {
    

// Variables globales
let options = document.querySelector(".product-options")

// Miniature image clicks
document.querySelectorAll(".product-miniature").forEach(el => {
  el.addEventListener("click", e => {
    // On récupère l'identifiant de la miniature
    let miniatureId = e.currentTarget.children[0].getAttribute("data-pm-id")
    // On trouve l'image correspondante
    let targetImage = document.querySelector(`[data-pi-id='${miniatureId}']`)
    // On récupère l'index de l'image
    let targetIndex = targetImage.parentElement.getAttribute("data-pi-index")
    // On met à jour l'image
    slideToProductImage(targetIndex)
    // On indique que le focus est sur cette image
    setCurrentActiveProductImage(targetIndex)
  })
})

// Product option clicks
document.querySelectorAll(".option-value").forEach(el => {
  el.addEventListener("click", e => {
    // Si l'option n'est pas disponible, ne rien faire
    if (e.currentTarget.classList.contains("unavailable")) return
    // On récupère la nouvelle option
    let newOption = e.currentTarget.getAttribute("data-option-value")
    // On met à jour visuellement les options actives
    changeSelectedOption(e.currentTarget.parentElement, newOption)
    // On met à jour les choix d'options disponibles
    updateOptionsAvailability()
    // On met à jour les infos produits
    updateProductData()
    // On met à jour la variante dans le master select
    changeSelectedVariant()
    // On met à jour l'image
    updateImage()
  })
})

// Scroll options (Desktop)
document.querySelectorAll(".product-option").forEach(el => {
  let numberOfOptions = parseInt(el.getAttribute("data-option-size"))
  if (window.screen.width > 1200 && numberOfOptions > 3) {
    el.querySelector(".option-values").addEventListener("wheel", e => {
      e.preventDefault()
      el.querySelector(".option-values").scrollLeft += 100 * e.deltaY / Math.abs(e.deltaY)
    })
  }
})

// Carousel arrow clicks
document.querySelectorAll(".option-value__arrow").forEach(el => {
  el.addEventListener("click", e => {
    let optionValues = el.parentElement.previousElementSibling
    if (el.classList.contains("previous")) optionValues.scroll({left: optionValues.scrollLeft - 100, behavior: 'smooth'})
    else {
      optionValues.scroll({top: 0, left: optionValues.scrollLeft + 100, behavior: 'smooth'})
      el.previousElementSibling.classList.remove("c-h")
    }
  })
})


document.querySelectorAll(".product-miniature__arrow").forEach(el => {
  el.addEventListener("click", e => {
    let miniatures = el.parentElement.previousElementSibling
    if (el.classList.contains("previous")) miniatures.scroll({top: miniatures.scrollTop - 100, behavior: 'smooth'})
    else miniatures.scroll({top: miniatures.scrollTop + 100, left: 0, behavior: 'smooth'})
  })
})

// Add to cart click
document.querySelector(".product-button.atc").addEventListener("click", e => addToJooneCart())


// Helper functions
function slideToProductImage(index) {
  // Si l'image n'est pas accessible, ne rien faire
  if (document.querySelector(`.product-image.index-${index}`) == null) return
  // Sinon, faire scroller le slider jusqu'à l'image
  document.querySelector(`.product-image.index-${index}`).scrollIntoView({ behavior: 'smooth', block: 'nearest' })
}

function setCurrentActiveProductImage(index) {
  // Si l'image n'est pas accessible, ne rien faire
  if (document.querySelector(`.product-image.index-${index}`) == null) return
  // Sinon, mettre à jour l'image active dans les données HTML
  document.querySelector(".product-images").setAttribute("data-active-index", index)
}


function slideToProductMiniature(index) {
  if (document.querySelector(`.product-miniature.index-${index}`) == null) return
  document.querySelector(`.product-miniature.index-${index}`).scrollIntoView({ behavior: 'smooth', block: 'nearest' })
}

function setCurrentActiveProductMiniature(index) {
  if (document.querySelector(`.product-miniature.index-${index}`) == null) return
  document.querySelector(".product-miniatures").setAttribute("data-active-index", index)
}

function changeSelectedOption(el, value) {
  // On met à jour l'option active dans les données HTML
  el.setAttribute("data-active-option", value)
  // On retire la bordure verte de l'option active précédente
  el.querySelector(".option-value.active").classList.remove("active")
  // On applique la bordure verte pour la nouvelle option active
  el.querySelector(`[data-option-value="${value}"]`).classList.add("active")
}

function getVariantId(firstOption, secondOption, thirdOption) {
  let variantName, variantId
  variantName = getVariantName(firstOption, secondOption, thirdOption)

  variantId = document.querySelector(`[data-variant-title="${variantName}"]`)?.getAttribute("value")
  return variantId
}

function getVariantName(firstOption, secondOption, thirdOption) {

  if (thirdOption == null && options.querySelector("[data-option-number='3']") != null) {
    thirdOption = options.querySelector("[data-option-number='3'] .option-values").getAttribute("data-active-option")
  }

  if (secondOption == null && options.querySelector("[data-option-number='2']") != null) {
    secondOption = options.querySelector("[data-option-number='2'] .option-values").getAttribute("data-active-option")
  }

  if (firstOption == null && options.querySelector("[data-option-number='1']") != null) {
    firstOption = options.querySelector("[data-option-number='1'] .option-values").getAttribute("data-active-option")
  }

  if (thirdOption != null) {
    variantName = firstOption + " / " + secondOption + " / " + thirdOption
  } else if (secondOption != null) {
    variantName = firstOption + " / " + secondOption
  } else {
    variantName = firstOption
  }

  return variantName
}

function updateOptionsAvailability() {
  let optionValue, variantId, variantAvailability
  let productOptionsLength
  let firstActiveOption = getActiveOptionName(1)
  let secondActiveOption = getActiveOptionName(2)
  let thirdActiveOption = getActiveOptionName(3)

  if (thirdActiveOption != null) {
    productOptionsLength = 3
  } else if (secondActiveOption != null) {
    productOptionsLength = 2
  } else {
    productOptionsLength = 1
  }

  if (productOptionsLength == 3) {
    options.querySelectorAll(`[data-option-number='1'] .option-value`).forEach(el => {
      optionValue = el.getAttribute("data-option-value")

      variantId = getVariantId(optionValue, secondActiveOption, thirdActiveOption)
      variantAvailability = options.querySelector(`[value='${variantId}']`)?.getAttribute("data-variant-available")
      toggleAvailableClass(el, variantAvailability == "true")
    })

    options.querySelectorAll(`[data-option-number='2'] .option-value`).forEach(el => {
      optionValue = el.getAttribute("data-option-value")
      variantId = getVariantId(firstActiveOption, optionValue, thirdActiveOption)
      variantAvailability = options.querySelector(`[value='${variantId}']`)?.getAttribute("data-variant-available")
      toggleAvailableClass(el, variantAvailability == "true")
    })

    options.querySelectorAll(`[data-option-number='3'] .option-value`).forEach(el => {
      optionValue = el.getAttribute("data-option-value")
      variantId = getVariantId(firstActiveOption, secondActiveOption, optionValue)
      variantAvailability = options.querySelector(`[value='${variantId}']`)?.getAttribute("data-variant-available")
      toggleAvailableClass(el, variantAvailability == "true")
    })
  } else if (productOptionsLength == 2) {
    options.querySelectorAll(`[data-option-number='1'] .option-value`).forEach(el => {
      optionValue = el.getAttribute("data-option-value")
      variantId = getVariantId(optionValue, secondActiveOption)
      variantAvailability = options.querySelector(`[value='${variantId}']`)?.getAttribute("data-variant-available")
      toggleAvailableClass(el, variantAvailability == "true")
    })

    options.querySelectorAll(`[data-option-number='2'] .option-value`).forEach(el => {
      optionValue = el.getAttribute("data-option-value")
      variantId = getVariantId(firstActiveOption, optionValue)
      variantAvailability = options.querySelector(`[value='${variantId}']`)?.getAttribute("data-variant-available")
      toggleAvailableClass(el, variantAvailability == "true")
    })
  } else {
    options.querySelectorAll(`[data-option-number='1'] .option-value`).forEach(el => {
      optionValue = el.getAttribute("data-option-value")
      variantId = getVariantId(optionValue)
      variantAvailability = options.querySelector(`[value='${variantId}']`)?.getAttribute("data-variant-available")
      toggleAvailableClass(el, variantAvailability == "true")
    })
  }
}

function toggleAvailableClass(el, available) {
  if (available) {
    el.classList.remove("unavailable")
    el.removeAttribute("disabled")
  } else {
    el.classList.add("unavailable")
    el.setAttribute("disabled", "")
  }
}

function getActiveOptionName(index) {
  let activeOptionName

  if (options.querySelector(`[data-option-number='${index}']`) == null) return null

  activeOptionName = options.querySelector(`[data-option-number='${index}'] .option-values`).getAttribute("data-active-option")

  return activeOptionName
}

function updateProductData() {
  let id = getVariantId()
  let newPrice = options.querySelector(`[value='${id}']`).getAttribute("data-variant-price")
  let newComparePrice = options.querySelector(`[value='${id}']`).getAttribute("data-variant-compare")
  let newAvailability = options.querySelector(`[value='${id}']`).getAttribute("data-variant-available")

  if (newComparePrice != "") document.querySelector(".product-compare").classList.remove("c-h")
  else document.querySelector(".product-compare").classList.add("c-h")

  document.querySelector(".product-compare").textContent = newComparePrice
  document.querySelector(".product-price").textContent = newPrice
  document.querySelector(".product-button.atc span").textContent = newPrice

  /*if(newAvailability == "true") {
    document.querySelector(".product-button.atc").classList.remove("c-h")
    document.querySelector(".product-button.oos").classList.add("c-h")
  } else {
    document.querySelector(".product-button.atc").classList.add("c-h")
    document.querySelector(".product-button.oos").classList.remove("c-h")
  }*/
}

const skuForVariant = (id) => window.ShopifyAnalytics.meta.product.variants.find(v => v.id == id)['sku']

function changeSelectedVariant() {
  const odijKitLink = document.querySelector('#odij-kit-link')
  const variantId = getVariantId()

  if (odijKitLink) {
    odijKitLink.href = `/pages/kit-essai-couche-pharmacies?sku=${skuForVariant(variantId)}&id=${variantId}`
  }
  options.querySelector(".product-variants__select").value = variantId
}

function updateImage() {
  let id = getVariantId()
  let newImageId = options.querySelector(`[value='${id}']`).getAttribute("data-variant-image")
  let targetImage = document.querySelector(`[data-pi-id='${newImageId}']`)
  if (targetImage != null) {
    let targetIndex = targetImage.parentElement.getAttribute("data-pi-index")
    slideToProductImage(targetIndex)
    setCurrentActiveProductImage(targetIndex)
  }
}

async function addToJooneCart() {
  document.querySelector(".s-header .cart .number").classList.remove("c-h")

  //await addVariantToCart(getVariantId(), 1)

  // Rafraichir l'incentive cart

  /*if (document.querySelector("#incentive-cart-popin") != null) document.querySelector("#incentive-cart-popin").style.display = "block"
  else if (document.querySelector("#incentive-cart-slide") != null) document.querySelector("#incentive-cart-slide").style.display = "block"
  else return console.log("No cart loaded on the page")*/
}

/*function addVariantToCart(id, quantity) {
  return new Promise(resolve => {
    let change = JSON.stringify({ 'id': id.toString(), 'quantity': quantity.toString() })

    let xhr = new XMLHttpRequest()

    xhr.onreadystatechange = function() { if (this.readyState == 4 && this.status == 200) resolve() }

    xhr.open("POST", "/cart/add.js", true)
    xhr.setRequestHeader("Content-Type", "application/json")
    xhr.send(change)
  })
}

function getCart() {
  return new Promise(resolve => {
    let xhr = new XMLHttpRequest()

    xhr.onreadystatechange = function() { if (this.readyState == 4 && this.status == 200) resolve() }

    xhr.open("GET", "/cart.js", true)
    xhr.send()
  })
}*/


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s-productDescription-couche-one"] && !window.DesignMode) return;
  try {
    

document.querySelector(".s-product-description .p-description").addEventListener("click", e => {
  document.querySelector(".s-product-description .p-description").classList.add("active")
  document.querySelector(".s-product-description .p-usage").classList.remove("active")
  document.querySelector(".s-product-description .p-composition").classList.remove("active")
  document.querySelector(".s-product-description .p-transparence").classList.remove("active")
  document.querySelector(".s-product-description .description").style.display = null
  document.querySelector(".s-product-description .usage").style.display = "none"
  document.querySelector(".s-product-description .composition").style.display = "none"
  document.querySelector(".s-product-description .transparence").style.display = "none"
})

document.querySelector(".s-product-description .p-usage").addEventListener("click", e => {
  document.querySelector(".s-product-description .p-description").classList.remove("active")
  document.querySelector(".s-product-description .p-usage").classList.add("active")
  document.querySelector(".s-product-description .p-composition").classList.remove("active")
  document.querySelector(".s-product-description .p-transparence").classList.remove("active")
  document.querySelector(".s-product-description .description").style.display = "none"
  document.querySelector(".s-product-description .usage").style.display = null
  document.querySelector(".s-product-description .composition").style.display = "none"
  document.querySelector(".s-product-description .transparence").style.display = "none"
})
document.querySelector(".s-product-description .p-composition").addEventListener("click", e => {
  document.querySelector(".s-product-description .p-description").classList.remove("active")
  document.querySelector(".s-product-description .p-composition").classList.add("active")
  document.querySelector(".s-product-description .p-usage").classList.remove("active")
  document.querySelector(".s-product-description .p-transparence").classList.remove("active")
  document.querySelector(".s-product-description .description").style.display = "none"
  document.querySelector(".s-product-description .composition").style.display = null
  document.querySelector(".s-product-description .usage").style.display = "none"
  document.querySelector(".s-product-description .transparence").style.display = "none"
})
document.querySelector(".s-product-description .p-transparence").addEventListener("click", e => {
  document.querySelector(".s-product-description .p-description").classList.remove("active")
  document.querySelector(".s-product-description .p-transparence").classList.add("active")
  document.querySelector(".s-product-description .p-composition").classList.remove("active")
  document.querySelector(".s-product-description .p-usage").classList.remove("active")
  document.querySelector(".s-product-description .description").style.display = "none"
  document.querySelector(".s-product-description .transparence").style.display = null
  document.querySelector(".s-product-description .composition").style.display = "none"
  document.querySelector(".s-product-description .usage").style.display = "none"
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s-productDescription"] && !window.DesignMode) return;
  try {
    

document.querySelector(".s-product-description .p-description").addEventListener("click", e => {
  document.querySelector(".s-product-description .p-description").classList.add("active")
  document.querySelector(".s-product-description .p-usage").classList.remove("active")

  document.querySelector(".s-product-description .description").style.display = null
  document.querySelector(".s-product-description .usage").style.display = "none"
})

document.querySelector(".s-product-description .p-usage").addEventListener("click", e => {
  document.querySelector(".s-product-description .p-description").classList.remove("active")
  document.querySelector(".s-product-description .p-usage").classList.add("active")

  document.querySelector(".s-product-description .description").style.display = "none"
  document.querySelector(".s-product-description .usage").style.display = null
})


  } catch(e) { console.error(e); }
})();
})();
